const dataExample=[
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-CAGR-062",
      "latitude": "30.377401",
      "longitude": "-107.952057",
      "hostid": 26166,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26166,
      "hostidP": "",
      "end_lat": "30.377401",
      "end_lon": "-107.952057",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-CAGR-062",
      "name_hostipC": "10.171.163.171",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.952057",
        "30.377401"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-CAGR-062",
      "latitude": "30.377401",
      "longitude": "-107.952057",
      "hostid": 26168,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26168,
      "hostidP": "",
      "end_lat": "30.377401",
      "end_lon": "-107.952057",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-CAGR-062",
      "name_hostipC": "10.171.163.172",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.952057",
        "30.377401"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-HIPA-097-PARRAL-CERRO_DE_ANGULO",
      "latitude": "26.941882",
      "longitude": "-105.68762",
      "hostid": 16818,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16818,
      "hostidP": "",
      "end_lat": "26.941882",
      "end_lon": "-105.68762",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-HIPA-097-PARRAL-CERRO_DE_ANGULO",
      "name_hostipC": "10.171.48.65",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.68762",
        "26.941882"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-JIME-091-JIMENEZ",
      "latitude": "27.1300244",
      "longitude": "-104.9196629",
      "hostid": 27786,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 27786,
      "hostidP": "",
      "end_lat": "27.1300244",
      "end_lon": "-104.9196629",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-JIME-091-JIMENEZ",
      "name_hostipC": "10.171.69.56",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.9196629",
        "27.1300244"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-BALL-115",
      "latitude": "26.955917",
      "longitude": "-106.351011",
      "hostid": 28654,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 28654,
      "hostidP": "",
      "end_lat": "26.955917",
      "end_lon": "-106.351011",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-BALL-115",
      "name_hostipC": "10.171.226.147",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.351011",
        "26.955917"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-BALL-113",
      "latitude": "26.954142",
      "longitude": "-106.346251",
      "hostid": 28655,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 28655,
      "hostidP": "",
      "end_lat": "26.954142",
      "end_lon": "-106.346251",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-BALL-113",
      "name_hostipC": "10.171.226.138",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.346251",
        "26.954142"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-BALL-115",
      "latitude": "26.955917",
      "longitude": "-106.351011",
      "hostid": 28656,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 28656,
      "hostidP": "",
      "end_lat": "26.955917",
      "end_lon": "-106.351011",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-BALL-115",
      "name_hostipC": "10.171.226.146",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.351011",
        "26.955917"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-BALL-116",
      "latitude": "26.94461",
      "longitude": "-106.35275",
      "hostid": 28657,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 28657,
      "hostidP": "",
      "end_lat": "26.94461",
      "end_lon": "-106.35275",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-BALL-116",
      "name_hostipC": "10.171.226.155",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.35275",
        "26.94461"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-BALL-116",
      "latitude": "26.94461",
      "longitude": "-106.35275",
      "hostid": 28658,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 28658,
      "hostidP": "",
      "end_lat": "26.94461",
      "end_lon": "-106.35275",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-BALL-116",
      "name_hostipC": "10.171.226.154",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.35275",
        "26.94461"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-BALL-117",
      "latitude": "26.951462",
      "longitude": "-106.348408",
      "hostid": 28660,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 28660,
      "hostidP": "",
      "end_lat": "26.951462",
      "end_lon": "-106.348408",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-BALL-117",
      "name_hostipC": "10.171.226.162",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.348408",
        "26.951462"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-BALL-117",
      "latitude": "26.951462",
      "longitude": "-106.348408",
      "hostid": 28661,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 28661,
      "hostidP": "",
      "end_lat": "26.951462",
      "end_lon": "-106.348408",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-BALL-117",
      "name_hostipC": "10.171.226.163",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.348408",
        "26.951462"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-DELI-138-DELICIAS",
      "latitude": "28.1923416",
      "longitude": "-105.4481841",
      "hostid": 30952,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30952,
      "hostidP": "",
      "end_lat": "28.1923416",
      "end_lon": "-105.4481841",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-DELI-138-DELICIAS",
      "name_hostipC": "10.171.136.115",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.4481841",
        "28.1923416"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-DELI-138-DELICIAS",
      "latitude": "28.1923416",
      "longitude": "-105.4481841",
      "hostid": 30953,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30953,
      "hostidP": "",
      "end_lat": "28.1923416",
      "end_lon": "-105.4481841",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-DELI-138-DELICIAS",
      "name_hostipC": "10.171.136.126",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.4481841",
        "28.1923416"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "latitude": "31.27163",
      "longitude": "-105.855702",
      "hostid": 23075,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 23075,
      "hostidP": "",
      "end_lat": "31.27163",
      "end_lon": "-105.855702",
      "name_hostC": "LPR1-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "name_hostipC": "10.171.226.90",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.855702",
        "31.27163"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "latitude": "31.27163",
      "longitude": "-105.855702",
      "hostid": 23076,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 23076,
      "hostidP": "",
      "end_lat": "31.27163",
      "end_lon": "-105.855702",
      "name_hostC": "LPR2-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "name_hostipC": "10.171.226.91",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.855702",
        "31.27163"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR02-VVU-AXIS-P1465-LE-CHIH01-VVU-HIPA-105",
      "latitude": "26.939237",
      "longitude": "-105.691614",
      "hostid": 23477,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 23477,
      "hostidP": "",
      "end_lat": "26.939237",
      "end_lon": "-105.691614",
      "name_hostC": "LPR02-VVU-AXIS-P1465-LE-CHIH01-VVU-HIPA-105",
      "name_hostipC": "10.171.48.70",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.691614",
        "26.939237"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-NUCG-030",
      "latitude": "30.412736",
      "longitude": "-107.908869",
      "hostid": 26208,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26208,
      "hostidP": "",
      "end_lat": "30.412736",
      "end_lon": "-107.908869",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-NUCG-030",
      "name_hostipC": "10.171.165.225",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.908869",
        "30.412736"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-AHUM-921",
      "latitude": "30.42548",
      "longitude": "-106.52178",
      "hostid": 30153,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30153,
      "hostidP": "",
      "end_lat": "30.42548",
      "end_lon": "-106.52178",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-AHUM-921",
      "name_hostipC": "10.171.85.162",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.52178",
        "30.42548"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-AHUM-921",
      "latitude": "30.42548",
      "longitude": "-106.52178",
      "hostid": 30153,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30153,
      "hostidP": "",
      "end_lat": "30.42548",
      "end_lon": "-106.52178",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-AHUM-921",
      "name_hostipC": "10.171.85.162",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.52178",
        "30.42548"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-MABE-149",
      "latitude": "29.122854",
      "longitude": "-103.916887",
      "hostid": 30306,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30306,
      "hostidP": "",
      "end_lat": "29.122854",
      "end_lon": "-103.916887",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-MABE-149",
      "name_hostipC": "10.171.86.242",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-103.916887",
        "29.122854"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-MABE-149",
      "latitude": "29.122854",
      "longitude": "-103.916887",
      "hostid": 30306,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30306,
      "hostidP": "",
      "end_lat": "29.122854",
      "end_lon": "-103.916887",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-MABE-149",
      "name_hostipC": "10.171.86.242",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-103.916887",
        "29.122854"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-CHIN-269",
      "latitude": "27.406273",
      "longitude": "-108.535811",
      "hostid": 30638,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30638,
      "hostidP": "",
      "end_lat": "27.406273",
      "end_lon": "-108.535811",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-CHIN-269",
      "name_hostipC": "10.171.91.146",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-108.535811",
        "27.406273"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-CHIN-269",
      "latitude": "27.406273",
      "longitude": "-108.535811",
      "hostid": 30638,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30638,
      "hostidP": "",
      "end_lat": "27.406273",
      "end_lon": "-108.535811",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-CHIN-269",
      "name_hostipC": "10.171.91.146",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-108.535811",
        "27.406273"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-BOCO-259",
      "latitude": "28.004352",
      "longitude": "-107.596108",
      "hostid": 30399,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30399,
      "hostidP": "",
      "end_lat": "28.004352",
      "end_lon": "-107.596108",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-BOCO-259",
      "name_hostipC": "10.171.89.82",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.596108",
        "28.004352"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-BOCO-259",
      "latitude": "28.004352",
      "longitude": "-107.596108",
      "hostid": 30399,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30399,
      "hostidP": "",
      "end_lat": "28.004352",
      "end_lon": "-107.596108",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-BOCO-259",
      "name_hostipC": "10.171.89.82",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.596108",
        "28.004352"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-MEOQ-210",
      "latitude": "28.296045",
      "longitude": "-105.505980",
      "hostid": 30429,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30429,
      "hostidP": "",
      "end_lat": "28.296045",
      "end_lon": "-105.505980",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-MEOQ-210",
      "name_hostipC": "10.171.92.18",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.505980",
        "28.296045"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-MEOQ-210",
      "latitude": "28.296045",
      "longitude": "-105.505980",
      "hostid": 30429,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30429,
      "hostidP": "",
      "end_lat": "28.296045",
      "end_lon": "-105.505980",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-MEOQ-210",
      "name_hostipC": "10.171.92.18",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.505980",
        "28.296045"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-COSO-148",
      "latitude": "29.452165",
      "longitude": "-105.09547",
      "hostid": 30159,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30159,
      "hostidP": "",
      "end_lat": "29.452165",
      "end_lon": "-105.09547",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-COSO-148",
      "name_hostipC": "10.171.86.226",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.09547",
        "29.452165"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-COSO-148",
      "latitude": "29.452165",
      "longitude": "-105.09547",
      "hostid": 30159,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30159,
      "hostidP": "",
      "end_lat": "29.452165",
      "end_lon": "-105.09547",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-COSO-148",
      "name_hostipC": "10.171.86.226",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.09547",
        "29.452165"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-GUAD-120",
      "latitude": "26.081852",
      "longitude": "-106.965892",
      "hostid": 30282,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30282,
      "hostidP": "",
      "end_lat": "26.081852",
      "end_lon": "-106.965892",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-GUAD-120",
      "name_hostipC": "10.171.91.50",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.965892",
        "26.081852"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-GUAD-120",
      "latitude": "26.081852",
      "longitude": "-106.965892",
      "hostid": 30282,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30282,
      "hostidP": "",
      "end_lat": "26.081852",
      "end_lon": "-106.965892",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-GUAD-120",
      "name_hostipC": "10.171.91.50",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.965892",
        "26.081852"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-GUAD-122",
      "latitude": "26.42442",
      "longitude": "-107.257918",
      "hostid": 30342,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30342,
      "hostidP": "",
      "end_lat": "26.42442",
      "end_lon": "-107.257918",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-GUAD-122",
      "name_hostipC": "10.171.91.82",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.257918",
        "26.42442"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-GUAD-122",
      "latitude": "26.42442",
      "longitude": "-107.257918",
      "hostid": 30342,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30342,
      "hostidP": "",
      "end_lat": "26.42442",
      "end_lon": "-107.257918",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-GUAD-122",
      "name_hostipC": "10.171.91.82",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.257918",
        "26.42442"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-GUAD-121",
      "latitude": "26.085847",
      "longitude": "-106.946886",
      "hostid": 30402,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30402,
      "hostidP": "",
      "end_lat": "26.085847",
      "end_lon": "-106.946886",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-GUAD-121",
      "name_hostipC": "10.171.91.66",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.946886",
        "26.085847"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-GUAD-121",
      "latitude": "26.085847",
      "longitude": "-106.946886",
      "hostid": 30402,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30402,
      "hostidP": "",
      "end_lat": "26.085847",
      "end_lon": "-106.946886",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-GUAD-121",
      "name_hostipC": "10.171.91.66",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.946886",
        "26.085847"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-BALL-119",
      "latitude": "26.944838",
      "longitude": "-106.348745",
      "hostid": 30253,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30253,
      "hostidP": "",
      "end_lat": "26.944838",
      "end_lon": "-106.348745",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-BALL-119",
      "name_hostipC": "10.171.88.50",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.348745",
        "26.944838"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-BALL-119",
      "latitude": "26.944838",
      "longitude": "-106.348745",
      "hostid": 30253,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30253,
      "hostidP": "",
      "end_lat": "26.944838",
      "end_lon": "-106.348745",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-BALL-119",
      "name_hostipC": "10.171.88.50",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.348745",
        "26.944838"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-SATE-211",
      "latitude": "27.974475",
      "longitude": "-106.124209",
      "hostid": 30324,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30324,
      "hostidP": "",
      "end_lat": "27.974475",
      "end_lon": "-106.124209",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-SATE-211",
      "name_hostipC": "10.171.88.130",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.124209",
        "27.974475"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-SATE-211",
      "latitude": "27.974475",
      "longitude": "-106.124209",
      "hostid": 30324,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30324,
      "hostidP": "",
      "end_lat": "27.974475",
      "end_lon": "-106.124209",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-SATE-211",
      "name_hostipC": "10.171.88.130",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.124209",
        "27.974475"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-BALL-118",
      "latitude": "26.952398",
      "longitude": "-106.363227",
      "hostid": 30326,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30326,
      "hostidP": "",
      "end_lat": "26.952398",
      "end_lon": "-106.363227",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-BALL-118",
      "name_hostipC": "10.171.88.34",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.363227",
        "26.952398"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-BALL-118",
      "latitude": "26.952398",
      "longitude": "-106.363227",
      "hostid": 30326,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30326,
      "hostidP": "",
      "end_lat": "26.952398",
      "end_lon": "-106.363227",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-BALL-118",
      "name_hostipC": "10.171.88.34",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.363227",
        "26.952398"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-MATA-204",
      "latitude": "28.864938",
      "longitude": "-107.765563",
      "hostid": 30357,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30357,
      "hostidP": "",
      "end_lat": "28.864938",
      "end_lon": "-107.765563",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-MATA-204",
      "name_hostipC": "10.171.91.226",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.765563",
        "28.864938"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-MATA-204",
      "latitude": "28.864938",
      "longitude": "-107.765563",
      "hostid": 30357,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30357,
      "hostidP": "",
      "end_lat": "28.864938",
      "end_lon": "-107.765563",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-MATA-204",
      "name_hostipC": "10.171.91.226",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.765563",
        "28.864938"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-CUAU-220",
      "latitude": "28.854319",
      "longitude": "-106.806658",
      "hostid": 30209,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30209,
      "hostidP": "",
      "end_lat": "28.854319",
      "end_lon": "-106.806658",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-CUAU-220",
      "name_hostipC": "10.171.89.2",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.806658",
        "28.854319"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-CUAU-220",
      "latitude": "28.854319",
      "longitude": "-106.806658",
      "hostid": 30209,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30209,
      "hostidP": "",
      "end_lat": "28.854319",
      "end_lon": "-106.806658",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-CUAU-220",
      "name_hostipC": "10.171.89.2",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.806658",
        "28.854319"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-NUCG-030",
      "latitude": "30.412736",
      "longitude": "-107.908869",
      "hostid": 26235,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26235,
      "hostidP": "",
      "end_lat": "30.412736",
      "end_lon": "-107.908869",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-NUCG-030",
      "name_hostipC": "10.171.165.226",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.908869",
        "30.412736"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-OJIN-001",
      "latitude": "29.5592",
      "longitude": "-104.422",
      "hostid": 30881,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30881,
      "hostidP": "",
      "end_lat": "29.5592",
      "end_lon": "-104.422",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-OJIN-001",
      "name_hostipC": "10.171.230.254",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.422",
        "29.5592"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-OJIN-001",
      "latitude": "29.5592",
      "longitude": "-104.422",
      "hostid": 30881,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30881,
      "hostidP": "",
      "end_lat": "29.5592",
      "end_lon": "-104.422",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-OJIN-001",
      "name_hostipC": "10.171.230.254",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.422",
        "29.5592"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-OJIN-001",
      "latitude": "29.5592",
      "longitude": "-104.422",
      "hostid": 30881,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30881,
      "hostidP": "",
      "end_lat": "29.5592",
      "end_lon": "-104.422",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-OJIN-001",
      "name_hostipC": "10.171.230.254",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.422",
        "29.5592"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-OJIN-001",
      "latitude": "29.5592",
      "longitude": "-104.422",
      "hostid": 30881,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30881,
      "hostidP": "",
      "end_lat": "29.5592",
      "end_lon": "-104.422",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-OJIN-001",
      "name_hostipC": "10.171.230.254",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.422",
        "29.5592"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-CAMA-001",
      "latitude": "27.669392",
      "longitude": "-105.169104",
      "hostid": 30864,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30864,
      "hostidP": "",
      "end_lat": "27.669392",
      "end_lon": "-105.169104",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.37.191",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.169104",
        "27.669392"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-CAMA-001",
      "latitude": "27.669392",
      "longitude": "-105.169104",
      "hostid": 30864,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30864,
      "hostidP": "",
      "end_lat": "27.669392",
      "end_lon": "-105.169104",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.37.191",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.169104",
        "27.669392"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-CAMA-001",
      "latitude": "27.669392",
      "longitude": "-105.169104",
      "hostid": 30864,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30864,
      "hostidP": "",
      "end_lat": "27.669392",
      "end_lon": "-105.169104",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.37.191",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.169104",
        "27.669392"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-CAMA-001",
      "latitude": "27.669392",
      "longitude": "-105.169104",
      "hostid": 30864,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30864,
      "hostidP": "",
      "end_lat": "27.669392",
      "end_lon": "-105.169104",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.37.191",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.169104",
        "27.669392"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-FIL-CDJU-008-ARCO_NORTE",
      "latitude": "31.426417",
      "longitude": "-106.46225",
      "hostid": 30997,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30997,
      "hostidP": "",
      "end_lat": "31.426417",
      "end_lon": "-106.46225",
      "name_hostC": "PTZ-TKH-CHIH01-FIL-CDJU-008-ARCO_NORTE",
      "name_hostipC": "10.171.95.231",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.46225",
        "31.426417"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-FIL-CDJU-008-ARCO_NORTE",
      "latitude": "31.426417",
      "longitude": "-106.46225",
      "hostid": 30997,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30997,
      "hostidP": "",
      "end_lat": "31.426417",
      "end_lon": "-106.46225",
      "name_hostC": "PTZ-TKH-CHIH01-FIL-CDJU-008-ARCO_NORTE",
      "name_hostipC": "10.171.95.231",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.46225",
        "31.426417"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-FIL-CDJU-008-ARCO_SUR",
      "latitude": "31.426417",
      "longitude": "-106.46225",
      "hostid": 31000,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31000,
      "hostidP": "",
      "end_lat": "31.426417",
      "end_lon": "-106.46225",
      "name_hostC": "PTZ-TKH-CHIH01-FIL-CDJU-008-ARCO_SUR",
      "name_hostipC": "10.171.95.226",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.46225",
        "31.426417"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-FIL-CDJU-008-ARCO_SUR",
      "latitude": "31.426417",
      "longitude": "-106.46225",
      "hostid": 31000,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31000,
      "hostidP": "",
      "end_lat": "31.426417",
      "end_lon": "-106.46225",
      "name_hostC": "PTZ-TKH-CHIH01-FIL-CDJU-008-ARCO_SUR",
      "name_hostipC": "10.171.95.226",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.46225",
        "31.426417"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-TRENDNET-CHIH01-VVU-CDJU-712-JUAREZ",
      "latitude": "31.54604",
      "longitude": "-106.368",
      "hostid": 30041,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30041,
      "hostidP": "",
      "end_lat": "31.54604",
      "end_lon": "-106.368",
      "name_hostC": "SWITCH-TRENDNET-CHIH01-VVU-CDJU-712-JUAREZ",
      "name_hostipC": "10.169.7.87",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.368",
        "31.54604"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-TRENDNET-CHIH01-VVU-CDJU-712-JUAREZ",
      "latitude": "31.54604",
      "longitude": "-106.368",
      "hostid": 30041,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30041,
      "hostidP": "",
      "end_lat": "31.54604",
      "end_lon": "-106.368",
      "name_hostC": "SWITCH-TRENDNET-CHIH01-VVU-CDJU-712-JUAREZ",
      "name_hostipC": "10.169.7.87",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.368",
        "31.54604"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-SIQURA-CHIH01-VVU-GUER-264",
      "latitude": "28.542935",
      "longitude": "-107.464593",
      "hostid": 31154,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31154,
      "hostidP": "",
      "end_lat": "28.542935",
      "end_lon": "-107.464593",
      "name_hostC": "PTZ-SIQURA-CHIH01-VVU-GUER-264",
      "name_hostipC": "10.171.89.146",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.464593",
        "28.542935"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-SIQURA-CHIH01-VVU-GUER-264",
      "latitude": "28.542935",
      "longitude": "-107.464593",
      "hostid": 31154,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31154,
      "hostidP": "",
      "end_lat": "28.542935",
      "end_lon": "-107.464593",
      "name_hostC": "PTZ-SIQURA-CHIH01-VVU-GUER-264",
      "name_hostipC": "10.171.89.146",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.464593",
        "28.542935"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-SIQURA-CHIH01-VVU-GUER-265",
      "latitude": "28.543225",
      "longitude": "-107.465595",
      "hostid": 31149,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31149,
      "hostidP": "",
      "end_lat": "28.543225",
      "end_lon": "-107.465595",
      "name_hostC": "PTZ-SIQURA-CHIH01-VVU-GUER-265",
      "name_hostipC": "10.171.89.162",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465595",
        "28.543225"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-SIQURA-CHIH01-VVU-GUER-265",
      "latitude": "28.543225",
      "longitude": "-107.465595",
      "hostid": 31149,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31149,
      "hostidP": "",
      "end_lat": "28.543225",
      "end_lon": "-107.465595",
      "name_hostC": "PTZ-SIQURA-CHIH01-VVU-GUER-265",
      "name_hostipC": "10.171.89.162",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465595",
        "28.543225"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-SIQURA-CHIH01-VVU-GUER-263",
      "latitude": "28.422366",
      "longitude": "-107.387083",
      "hostid": 31147,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31147,
      "hostidP": "",
      "end_lat": "28.422366",
      "end_lon": "-107.387083",
      "name_hostC": "PTZ-SIQURA-CHIH01-VVU-GUER-263",
      "name_hostipC": "10.171.89.130",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.387083",
        "28.422366"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-SIQURA-CHIH01-VVU-GUER-263",
      "latitude": "28.422366",
      "longitude": "-107.387083",
      "hostid": 31147,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31147,
      "hostidP": "",
      "end_lat": "28.422366",
      "end_lon": "-107.387083",
      "name_hostC": "PTZ-SIQURA-CHIH01-VVU-GUER-263",
      "name_hostipC": "10.171.89.130",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.387083",
        "28.422366"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-SIQURA-CHIH01-VVU-GUER-264",
      "latitude": "28.542935",
      "longitude": "-107.464593",
      "hostid": 31145,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31145,
      "hostidP": "",
      "end_lat": "28.542935",
      "end_lon": "-107.464593",
      "name_hostC": "F1-SIQURA-CHIH01-VVU-GUER-264",
      "name_hostipC": "10.171.89.147",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.464593",
        "28.542935"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-SIQURA-CHIH01-VVU-GUER-264",
      "latitude": "28.542935",
      "longitude": "-107.464593",
      "hostid": 31145,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31145,
      "hostidP": "",
      "end_lat": "28.542935",
      "end_lon": "-107.464593",
      "name_hostC": "F1-SIQURA-CHIH01-VVU-GUER-264",
      "name_hostipC": "10.171.89.147",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.464593",
        "28.542935"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-SIQURA-CHIH01-VVU-GUER-265",
      "latitude": "28.543225",
      "longitude": "-107.465595",
      "hostid": 31159,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31159,
      "hostidP": "",
      "end_lat": "28.543225",
      "end_lon": "-107.465595",
      "name_hostC": "F2-SIQURA-CHIH01-VVU-GUER-265",
      "name_hostipC": "10.171.89.164",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465595",
        "28.543225"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-SIQURA-CHIH01-VVU-GUER-265",
      "latitude": "28.543225",
      "longitude": "-107.465595",
      "hostid": 31159,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31159,
      "hostidP": "",
      "end_lat": "28.543225",
      "end_lon": "-107.465595",
      "name_hostC": "F2-SIQURA-CHIH01-VVU-GUER-265",
      "name_hostipC": "10.171.89.164",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465595",
        "28.543225"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-SIQURA-CHIH01-VVU-GUER-263",
      "latitude": "28.422366",
      "longitude": "-107.387083",
      "hostid": 31144,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31144,
      "hostidP": "",
      "end_lat": "28.422366",
      "end_lon": "-107.387083",
      "name_hostC": "F1-SIQURA-CHIH01-VVU-GUER-263",
      "name_hostipC": "10.171.89.131",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.387083",
        "28.422366"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-SIQURA-CHIH01-VVU-GUER-263",
      "latitude": "28.422366",
      "longitude": "-107.387083",
      "hostid": 31144,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31144,
      "hostidP": "",
      "end_lat": "28.422366",
      "end_lon": "-107.387083",
      "name_hostC": "F1-SIQURA-CHIH01-VVU-GUER-263",
      "name_hostipC": "10.171.89.131",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.387083",
        "28.422366"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-SIQURA-CHIH01-VVU-GUER-263",
      "latitude": "28.422366",
      "longitude": "-107.387083",
      "hostid": 31160,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31160,
      "hostidP": "",
      "end_lat": "28.422366",
      "end_lon": "-107.387083",
      "name_hostC": "F2-SIQURA-CHIH01-VVU-GUER-263",
      "name_hostipC": "10.171.89.132",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.387083",
        "28.422366"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-SIQURA-CHIH01-VVU-GUER-263",
      "latitude": "28.422366",
      "longitude": "-107.387083",
      "hostid": 31160,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31160,
      "hostidP": "",
      "end_lat": "28.422366",
      "end_lon": "-107.387083",
      "name_hostC": "F2-SIQURA-CHIH01-VVU-GUER-263",
      "name_hostipC": "10.171.89.132",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.387083",
        "28.422366"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-SIQURA-CHIH01-VVU-GUER-264",
      "latitude": "28.542935",
      "longitude": "-107.464593",
      "hostid": 31163,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31163,
      "hostidP": "",
      "end_lat": "28.542935",
      "end_lon": "-107.464593",
      "name_hostC": "F2-SIQURA-CHIH01-VVU-GUER-264",
      "name_hostipC": "10.171.89.148",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.464593",
        "28.542935"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-SIQURA-CHIH01-VVU-GUER-264",
      "latitude": "28.542935",
      "longitude": "-107.464593",
      "hostid": 31163,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31163,
      "hostidP": "",
      "end_lat": "28.542935",
      "end_lon": "-107.464593",
      "name_hostC": "F2-SIQURA-CHIH01-VVU-GUER-264",
      "name_hostipC": "10.171.89.148",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.464593",
        "28.542935"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-SIQURA-CHIH01-VVU-GUER-265",
      "latitude": "28.543225",
      "longitude": "-107.465595",
      "hostid": 31162,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31162,
      "hostidP": "",
      "end_lat": "28.543225",
      "end_lon": "-107.465595",
      "name_hostC": "F1-SIQURA-CHIH01-VVU-GUER-265",
      "name_hostipC": "10.171.89.163",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465595",
        "28.543225"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-SIQURA-CHIH01-VVU-GUER-265",
      "latitude": "28.543225",
      "longitude": "-107.465595",
      "hostid": 31162,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31162,
      "hostidP": "",
      "end_lat": "28.543225",
      "end_lon": "-107.465595",
      "name_hostC": "F1-SIQURA-CHIH01-VVU-GUER-265",
      "name_hostipC": "10.171.89.163",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465595",
        "28.543225"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-GUER-265",
      "latitude": "28.543225",
      "longitude": "-107.465595",
      "hostid": 31194,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31194,
      "hostidP": "",
      "end_lat": "28.543225",
      "end_lon": "-107.465595",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-GUER-265",
      "name_hostipC": "10.171.74.164",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465595",
        "28.543225"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-GUER-265",
      "latitude": "28.543225",
      "longitude": "-107.465595",
      "hostid": 31194,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31194,
      "hostidP": "",
      "end_lat": "28.543225",
      "end_lon": "-107.465595",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-GUER-265",
      "name_hostipC": "10.171.74.164",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465595",
        "28.543225"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-GUER-264",
      "latitude": "28.542935",
      "longitude": "-107.464593",
      "hostid": 31197,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31197,
      "hostidP": "",
      "end_lat": "28.542935",
      "end_lon": "-107.464593",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-GUER-264",
      "name_hostipC": "10.171.74.148",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.464593",
        "28.542935"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-GUER-264",
      "latitude": "28.542935",
      "longitude": "-107.464593",
      "hostid": 31197,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31197,
      "hostidP": "",
      "end_lat": "28.542935",
      "end_lon": "-107.464593",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-GUER-264",
      "name_hostipC": "10.171.74.148",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.464593",
        "28.542935"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-GUER-001",
      "latitude": "28.4255115",
      "longitude": "-107.3825344",
      "hostid": 31176,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31176,
      "hostidP": "",
      "end_lat": "28.4255115",
      "end_lon": "-107.3825344",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-GUER-001",
      "name_hostipC": "10.171.74.134",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.3825344",
        "28.4255115"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-GUER-001",
      "latitude": "28.4255115",
      "longitude": "-107.3825344",
      "hostid": 31176,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31176,
      "hostidP": "",
      "end_lat": "28.4255115",
      "end_lon": "-107.3825344",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-GUER-001",
      "name_hostipC": "10.171.74.134",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.3825344",
        "28.4255115"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-GUER-263",
      "latitude": "28.422366",
      "longitude": "-107.387083",
      "hostid": 31178,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31178,
      "hostidP": "",
      "end_lat": "28.422366",
      "end_lon": "-107.387083",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-GUER-263",
      "name_hostipC": "10.171.74.132",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.387083",
        "28.422366"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-GUER-263",
      "latitude": "28.422366",
      "longitude": "-107.387083",
      "hostid": 31178,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31178,
      "hostidP": "",
      "end_lat": "28.422366",
      "end_lon": "-107.387083",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-GUER-263",
      "name_hostipC": "10.171.74.132",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.387083",
        "28.422366"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-GUER-002",
      "latitude": "28.542985",
      "longitude": "-107.465077",
      "hostid": 31190,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31190,
      "hostidP": "",
      "end_lat": "28.542985",
      "end_lon": "-107.465077",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-GUER-002",
      "name_hostipC": "10.171.74.150",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465077",
        "28.542985"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-GUER-002",
      "latitude": "28.542985",
      "longitude": "-107.465077",
      "hostid": 31190,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31190,
      "hostidP": "",
      "end_lat": "28.542985",
      "end_lon": "-107.465077",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-GUER-002",
      "name_hostipC": "10.171.74.150",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465077",
        "28.542985"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-GUER-003",
      "latitude": "28.543179",
      "longitude": "-107.465083",
      "hostid": 31185,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31185,
      "hostidP": "",
      "end_lat": "28.543179",
      "end_lon": "-107.465083",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-GUER-003",
      "name_hostipC": "10.171.74.166",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465083",
        "28.543179"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-GUER-003",
      "latitude": "28.543179",
      "longitude": "-107.465083",
      "hostid": 31185,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31185,
      "hostidP": "",
      "end_lat": "28.543179",
      "end_lon": "-107.465083",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-GUER-003",
      "name_hostipC": "10.171.74.166",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465083",
        "28.543179"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-CHIH01-ARC-GUER-002",
      "latitude": "28.542985",
      "longitude": "-107.465077",
      "hostid": 31180,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31180,
      "hostidP": "",
      "end_lat": "28.542985",
      "end_lon": "-107.465077",
      "name_hostC": "LPR2-TATTILE-CHIH01-ARC-GUER-002",
      "name_hostipC": "10.171.89.151",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465077",
        "28.542985"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-CHIH01-ARC-GUER-002",
      "latitude": "28.542985",
      "longitude": "-107.465077",
      "hostid": 31180,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31180,
      "hostidP": "",
      "end_lat": "28.542985",
      "end_lon": "-107.465077",
      "name_hostC": "LPR2-TATTILE-CHIH01-ARC-GUER-002",
      "name_hostipC": "10.171.89.151",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465077",
        "28.542985"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-CHIH01-ARC-GUER-003",
      "latitude": "28.543179",
      "longitude": "-107.465083",
      "hostid": 31182,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31182,
      "hostidP": "",
      "end_lat": "28.543179",
      "end_lon": "-107.465083",
      "name_hostC": "LPR2-TATTILE-CHIH01-ARC-GUER-003",
      "name_hostipC": "10.171.89.166",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465083",
        "28.543179"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-CHIH01-ARC-GUER-003",
      "latitude": "28.543179",
      "longitude": "-107.465083",
      "hostid": 31182,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31182,
      "hostidP": "",
      "end_lat": "28.543179",
      "end_lon": "-107.465083",
      "name_hostC": "LPR2-TATTILE-CHIH01-ARC-GUER-003",
      "name_hostipC": "10.171.89.166",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465083",
        "28.543179"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-CHIH01-ARC-GUER-001",
      "latitude": "28.4255115",
      "longitude": "-107.3825344",
      "hostid": 31191,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31191,
      "hostidP": "",
      "end_lat": "28.4255115",
      "end_lon": "-107.3825344",
      "name_hostC": "LPR2-TATTILE-CHIH01-ARC-GUER-001",
      "name_hostipC": "10.171.89.135",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.3825344",
        "28.4255115"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-CHIH01-ARC-GUER-001",
      "latitude": "28.4255115",
      "longitude": "-107.3825344",
      "hostid": 31191,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31191,
      "hostidP": "",
      "end_lat": "28.4255115",
      "end_lon": "-107.3825344",
      "name_hostC": "LPR2-TATTILE-CHIH01-ARC-GUER-001",
      "name_hostipC": "10.171.89.135",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.3825344",
        "28.4255115"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-CHIH01-ARC-GUER-003",
      "latitude": "28.543179",
      "longitude": "-107.465083",
      "hostid": 31181,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31181,
      "hostidP": "",
      "end_lat": "28.543179",
      "end_lon": "-107.465083",
      "name_hostC": "LPR1-TATTILE-CHIH01-ARC-GUER-003",
      "name_hostipC": "10.171.89.165",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465083",
        "28.543179"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-CHIH01-ARC-GUER-003",
      "latitude": "28.543179",
      "longitude": "-107.465083",
      "hostid": 31181,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31181,
      "hostidP": "",
      "end_lat": "28.543179",
      "end_lon": "-107.465083",
      "name_hostC": "LPR1-TATTILE-CHIH01-ARC-GUER-003",
      "name_hostipC": "10.171.89.165",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465083",
        "28.543179"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-CHIH01-ARC-GUER-001",
      "latitude": "28.4255115",
      "longitude": "-107.3825344",
      "hostid": 31172,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31172,
      "hostidP": "",
      "end_lat": "28.4255115",
      "end_lon": "-107.3825344",
      "name_hostC": "LPR1-TATTILE-CHIH01-ARC-GUER-001",
      "name_hostipC": "10.171.89.134",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.3825344",
        "28.4255115"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-CHIH01-ARC-GUER-001",
      "latitude": "28.4255115",
      "longitude": "-107.3825344",
      "hostid": 31172,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31172,
      "hostidP": "",
      "end_lat": "28.4255115",
      "end_lon": "-107.3825344",
      "name_hostC": "LPR1-TATTILE-CHIH01-ARC-GUER-001",
      "name_hostipC": "10.171.89.134",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.3825344",
        "28.4255115"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-CHIH01-ARC-GUER-002",
      "latitude": "28.542985",
      "longitude": "-107.465077",
      "hostid": 31169,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31169,
      "hostidP": "",
      "end_lat": "28.542985",
      "end_lon": "-107.465077",
      "name_hostC": "LPR1-TATTILE-CHIH01-ARC-GUER-002",
      "name_hostipC": "10.171.89.150",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465077",
        "28.542985"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-CHIH01-ARC-GUER-002",
      "latitude": "28.542985",
      "longitude": "-107.465077",
      "hostid": 31169,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31169,
      "hostidP": "",
      "end_lat": "28.542985",
      "end_lon": "-107.465077",
      "name_hostC": "LPR1-TATTILE-CHIH01-ARC-GUER-002",
      "name_hostipC": "10.171.89.150",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.465077",
        "28.542985"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "ACCESSPOINT-EWC-CISCO-CHIH01-CMM-CAMA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31311,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31311,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "ACCESSPOINT-EWC-CISCO-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.24.138",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "ACCESSPOINT-EWC-CISCO-CHIH01-CMM-CAMA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31311,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31311,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "ACCESSPOINT-EWC-CISCO-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.24.138",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-CHIH01-ARC-IGZA-003",
      "latitude": "29.580191",
      "longitude": "-107.726829",
      "hostid": 30550,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30550,
      "hostidP": "",
      "end_lat": "29.580191",
      "end_lon": "-107.726829",
      "name_hostC": "LPR1-TATTILE-CHIH01-ARC-IGZA-003",
      "name_hostipC": "10.171.86.198",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.726829",
        "29.580191"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-CHIH01-ARC-IGZA-003",
      "latitude": "29.580191",
      "longitude": "-107.726829",
      "hostid": 30550,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30550,
      "hostidP": "",
      "end_lat": "29.580191",
      "end_lon": "-107.726829",
      "name_hostC": "LPR1-TATTILE-CHIH01-ARC-IGZA-003",
      "name_hostipC": "10.171.86.198",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.726829",
        "29.580191"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-Smart-CHIH01-ARC-IGZA-002",
      "latitude": "29.637535",
      "longitude": "-107.755502",
      "hostid": 30523,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30523,
      "hostidP": "",
      "end_lat": "29.637535",
      "end_lon": "-107.755502",
      "name_hostC": "LPR2-TATTILE-Smart-CHIH01-ARC-IGZA-002",
      "name_hostipC": "10.171.86.183",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.755502",
        "29.637535"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-Smart-CHIH01-ARC-IGZA-002",
      "latitude": "29.637535",
      "longitude": "-107.755502",
      "hostid": 30523,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30523,
      "hostidP": "",
      "end_lat": "29.637535",
      "end_lon": "-107.755502",
      "name_hostC": "LPR2-TATTILE-Smart-CHIH01-ARC-IGZA-002",
      "name_hostipC": "10.171.86.183",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.755502",
        "29.637535"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-IGZA-202",
      "latitude": "29.637952",
      "longitude": "-107.755536",
      "hostid": 30099,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30099,
      "hostidP": "",
      "end_lat": "29.637952",
      "end_lon": "-107.755536",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-IGZA-202",
      "name_hostipC": "10.171.71.180",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.755536",
        "29.637952"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-IGZA-202",
      "latitude": "29.637952",
      "longitude": "-107.755536",
      "hostid": 30099,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30099,
      "hostidP": "",
      "end_lat": "29.637952",
      "end_lon": "-107.755536",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-IGZA-202",
      "name_hostipC": "10.171.71.180",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.755536",
        "29.637952"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-ARC-MADE-003-MADERA-SUSCRIPTOR_ARCO",
      "latitude": "29.178854",
      "longitude": "-108.126164",
      "hostid": 31167,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31167,
      "hostidP": "",
      "end_lat": "29.178854",
      "end_lon": "-108.126164",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-ARC-MADE-003-MADERA-SUSCRIPTOR_ARCO",
      "name_hostipC": "10.171.75.37",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-108.126164",
        "29.178854"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-ARC-MADE-003-MADERA-SUSCRIPTOR_ARCO",
      "latitude": "29.178854",
      "longitude": "-108.126164",
      "hostid": 31167,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31167,
      "hostidP": "",
      "end_lat": "29.178854",
      "end_lon": "-108.126164",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-ARC-MADE-003-MADERA-SUSCRIPTOR_ARCO",
      "name_hostipC": "10.171.75.37",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-108.126164",
        "29.178854"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-Siqura-CHIH01-VVU-IGZA-202",
      "latitude": "29.637952",
      "longitude": "-107.755536",
      "hostid": 30084,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30084,
      "hostidP": "",
      "end_lat": "29.637952",
      "end_lon": "-107.755536",
      "name_hostC": "F1-Siqura-CHIH01-VVU-IGZA-202",
      "name_hostipC": "10.171.86.179",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.755536",
        "29.637952"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-Siqura-CHIH01-VVU-IGZA-202",
      "latitude": "29.637952",
      "longitude": "-107.755536",
      "hostid": 30084,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30084,
      "hostidP": "",
      "end_lat": "29.637952",
      "end_lon": "-107.755536",
      "name_hostC": "F1-Siqura-CHIH01-VVU-IGZA-202",
      "name_hostipC": "10.171.86.179",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.755536",
        "29.637952"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-IGZA-201",
      "latitude": "29.661805",
      "longitude": "-107.751807",
      "hostid": 30161,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30161,
      "hostidP": "",
      "end_lat": "29.661805",
      "end_lon": "-107.751807",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-IGZA-201",
      "name_hostipC": "10.171.71.164",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.751807",
        "29.661805"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-IGZA-201",
      "latitude": "29.661805",
      "longitude": "-107.751807",
      "hostid": 30161,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30161,
      "hostidP": "",
      "end_lat": "29.661805",
      "end_lon": "-107.751807",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-IGZA-201",
      "name_hostipC": "10.171.71.164",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.751807",
        "29.661805"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-CHIH01-ARC-MADE-003",
      "latitude": "29.178854",
      "longitude": "-108.126164",
      "hostid": 31175,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31175,
      "hostidP": "",
      "end_lat": "29.178854",
      "end_lon": "-108.126164",
      "name_hostC": "LPR1-TATTILE-CHIH01-ARC-MADE-003",
      "name_hostipC": "10.171.91.38",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-108.126164",
        "29.178854"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-CHIH01-ARC-MADE-003",
      "latitude": "29.178854",
      "longitude": "-108.126164",
      "hostid": 31175,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31175,
      "hostidP": "",
      "end_lat": "29.178854",
      "end_lon": "-108.126164",
      "name_hostC": "LPR1-TATTILE-CHIH01-ARC-MADE-003",
      "name_hostipC": "10.171.91.38",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-108.126164",
        "29.178854"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-Smart-CHIH01-ARC-IGZA-002",
      "latitude": "29.637535",
      "longitude": "-107.755502",
      "hostid": 30579,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30579,
      "hostidP": "",
      "end_lat": "29.637535",
      "end_lon": "-107.755502",
      "name_hostC": "LPR1-TATTILE-Smart-CHIH01-ARC-IGZA-002",
      "name_hostipC": "10.171.86.182",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.755502",
        "29.637535"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-Smart-CHIH01-ARC-IGZA-002",
      "latitude": "29.637535",
      "longitude": "-107.755502",
      "hostid": 30579,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30579,
      "hostidP": "",
      "end_lat": "29.637535",
      "end_lon": "-107.755502",
      "name_hostC": "LPR1-TATTILE-Smart-CHIH01-ARC-IGZA-002",
      "name_hostipC": "10.171.86.182",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.755502",
        "29.637535"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-IGZA-201",
      "latitude": "29.661805",
      "longitude": "-107.751807",
      "hostid": 30175,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30175,
      "hostidP": "",
      "end_lat": "29.661805",
      "end_lon": "-107.751807",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-IGZA-201",
      "name_hostipC": "10.171.86.162",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.751807",
        "29.661805"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-IGZA-201",
      "latitude": "29.661805",
      "longitude": "-107.751807",
      "hostid": 30175,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30175,
      "hostidP": "",
      "end_lat": "29.661805",
      "end_lon": "-107.751807",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-IGZA-201",
      "name_hostipC": "10.171.86.162",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.751807",
        "29.661805"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-IGZA-001",
      "latitude": "29.662142",
      "longitude": "-107.751131",
      "hostid": 30409,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30409,
      "hostidP": "",
      "end_lat": "29.662142",
      "end_lon": "-107.751131",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-IGZA-001",
      "name_hostipC": "10.171.71.166",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.751131",
        "29.662142"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-IGZA-001",
      "latitude": "29.662142",
      "longitude": "-107.751131",
      "hostid": 30409,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30409,
      "hostidP": "",
      "end_lat": "29.662142",
      "end_lon": "-107.751131",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-IGZA-001",
      "name_hostipC": "10.171.71.166",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.751131",
        "29.662142"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-CHIH01-ARC-IGZA-003",
      "latitude": "29.580191",
      "longitude": "-107.726829",
      "hostid": 30582,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30582,
      "hostidP": "",
      "end_lat": "29.580191",
      "end_lon": "-107.726829",
      "name_hostC": "LPR2-TATTILE-CHIH01-ARC-IGZA-003",
      "name_hostipC": "10.171.86.199",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.726829",
        "29.580191"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-CHIH01-ARC-IGZA-003",
      "latitude": "29.580191",
      "longitude": "-107.726829",
      "hostid": 30582,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30582,
      "hostidP": "",
      "end_lat": "29.580191",
      "end_lon": "-107.726829",
      "name_hostC": "LPR2-TATTILE-CHIH01-ARC-IGZA-003",
      "name_hostipC": "10.171.86.199",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.726829",
        "29.580191"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-IGZA-003",
      "latitude": "29.580191",
      "longitude": "-107.726829",
      "hostid": 30170,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30170,
      "hostidP": "",
      "end_lat": "29.580191",
      "end_lon": "-107.726829",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-IGZA-003",
      "name_hostipC": "10.171.71.198",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.726829",
        "29.580191"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-IGZA-003",
      "latitude": "29.580191",
      "longitude": "-107.726829",
      "hostid": 30170,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30170,
      "hostidP": "",
      "end_lat": "29.580191",
      "end_lon": "-107.726829",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-IGZA-003",
      "name_hostipC": "10.171.71.198",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.726829",
        "29.580191"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-Smart-CHIH01-ARC-IGZA-001",
      "latitude": "29.662142",
      "longitude": "-107.751131",
      "hostid": 30463,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30463,
      "hostidP": "",
      "end_lat": "29.662142",
      "end_lon": "-107.751131",
      "name_hostC": "LPR2-TATTILE-Smart-CHIH01-ARC-IGZA-001",
      "name_hostipC": "10.171.86.167",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.751131",
        "29.662142"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-Smart-CHIH01-ARC-IGZA-001",
      "latitude": "29.662142",
      "longitude": "-107.751131",
      "hostid": 30463,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30463,
      "hostidP": "",
      "end_lat": "29.662142",
      "end_lon": "-107.751131",
      "name_hostC": "LPR2-TATTILE-Smart-CHIH01-ARC-IGZA-001",
      "name_hostipC": "10.171.86.167",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.751131",
        "29.662142"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-Smart-CHIH01-ARC-IGZA-001",
      "latitude": "29.662142",
      "longitude": "-107.751131",
      "hostid": 30487,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30487,
      "hostidP": "",
      "end_lat": "29.662142",
      "end_lon": "-107.751131",
      "name_hostC": "LPR1-TATTILE-Smart-CHIH01-ARC-IGZA-001",
      "name_hostipC": "10.171.86.166",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.751131",
        "29.662142"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-Smart-CHIH01-ARC-IGZA-001",
      "latitude": "29.662142",
      "longitude": "-107.751131",
      "hostid": 30487,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30487,
      "hostidP": "",
      "end_lat": "29.662142",
      "end_lon": "-107.751131",
      "name_hostC": "LPR1-TATTILE-Smart-CHIH01-ARC-IGZA-001",
      "name_hostipC": "10.171.86.166",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.751131",
        "29.662142"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-IGZA-203",
      "latitude": "29.580191",
      "longitude": "-107.726829",
      "hostid": 30163,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30163,
      "hostidP": "",
      "end_lat": "29.580191",
      "end_lon": "-107.726829",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-IGZA-203",
      "name_hostipC": "10.171.71.196",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.726829",
        "29.580191"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-IGZA-203",
      "latitude": "29.580191",
      "longitude": "-107.726829",
      "hostid": 30163,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30163,
      "hostidP": "",
      "end_lat": "29.580191",
      "end_lon": "-107.726829",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-IGZA-203",
      "name_hostipC": "10.171.71.196",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.726829",
        "29.580191"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-Siqura-CHIH01-VVU-IGZA-202",
      "latitude": "29.637952",
      "longitude": "-107.755536",
      "hostid": 30241,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30241,
      "hostidP": "",
      "end_lat": "29.637952",
      "end_lon": "-107.755536",
      "name_hostC": "F2-Siqura-CHIH01-VVU-IGZA-202",
      "name_hostipC": "10.171.86.180",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.755536",
        "29.637952"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-Siqura-CHIH01-VVU-IGZA-202",
      "latitude": "29.637952",
      "longitude": "-107.755536",
      "hostid": 30241,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30241,
      "hostidP": "",
      "end_lat": "29.637952",
      "end_lon": "-107.755536",
      "name_hostC": "F2-Siqura-CHIH01-VVU-IGZA-202",
      "name_hostipC": "10.171.86.180",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.755536",
        "29.637952"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-Siqura-CHIH01-VVU-IGZA-203",
      "latitude": "29.580191",
      "longitude": "-107.726829",
      "hostid": 30236,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30236,
      "hostidP": "",
      "end_lat": "29.580191",
      "end_lon": "-107.726829",
      "name_hostC": "F2-Siqura-CHIH01-VVU-IGZA-203",
      "name_hostipC": "10.171.86.196",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.726829",
        "29.580191"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-Siqura-CHIH01-VVU-IGZA-203",
      "latitude": "29.580191",
      "longitude": "-107.726829",
      "hostid": 30236,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30236,
      "hostidP": "",
      "end_lat": "29.580191",
      "end_lon": "-107.726829",
      "name_hostC": "F2-Siqura-CHIH01-VVU-IGZA-203",
      "name_hostipC": "10.171.86.196",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.726829",
        "29.580191"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-Siqura-CHIH01-VVU-IGZA-201",
      "latitude": "29.661805",
      "longitude": "-107.751807",
      "hostid": 30093,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30093,
      "hostidP": "",
      "end_lat": "29.661805",
      "end_lon": "-107.751807",
      "name_hostC": "F1-Siqura-CHIH01-VVU-IGZA-201",
      "name_hostipC": "10.171.86.163",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.751807",
        "29.661805"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-Siqura-CHIH01-VVU-IGZA-201",
      "latitude": "29.661805",
      "longitude": "-107.751807",
      "hostid": 30093,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30093,
      "hostidP": "",
      "end_lat": "29.661805",
      "end_lon": "-107.751807",
      "name_hostC": "F1-Siqura-CHIH01-VVU-IGZA-201",
      "name_hostipC": "10.171.86.163",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.751807",
        "29.661805"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-IGZA-002",
      "latitude": "29.637535",
      "longitude": "-107.755502",
      "hostid": 30087,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30087,
      "hostidP": "",
      "end_lat": "29.637535",
      "end_lon": "-107.755502",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-IGZA-002",
      "name_hostipC": "10.171.71.182",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.755502",
        "29.637535"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-IGZA-002",
      "latitude": "29.637535",
      "longitude": "-107.755502",
      "hostid": 30087,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30087,
      "hostidP": "",
      "end_lat": "29.637535",
      "end_lon": "-107.755502",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-IGZA-002",
      "name_hostipC": "10.171.71.182",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.755502",
        "29.637535"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-MADE-003",
      "latitude": "29.178854",
      "longitude": "-108.126164",
      "hostid": 31179,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31179,
      "hostidP": "",
      "end_lat": "29.178854",
      "end_lon": "-108.126164",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-MADE-003",
      "name_hostipC": "10.171.75.38",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-108.126164",
        "29.178854"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-MADE-003",
      "latitude": "29.178854",
      "longitude": "-108.126164",
      "hostid": 31179,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31179,
      "hostidP": "",
      "end_lat": "29.178854",
      "end_lon": "-108.126164",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-MADE-003",
      "name_hostipC": "10.171.75.38",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-108.126164",
        "29.178854"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-Siqura-CHIH01-VVU-IGZA-203",
      "latitude": "29.580191",
      "longitude": "-107.726829",
      "hostid": 30095,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30095,
      "hostidP": "",
      "end_lat": "29.580191",
      "end_lon": "-107.726829",
      "name_hostC": "F1-Siqura-CHIH01-VVU-IGZA-203",
      "name_hostipC": "10.171.86.195",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.726829",
        "29.580191"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-Siqura-CHIH01-VVU-IGZA-203",
      "latitude": "29.580191",
      "longitude": "-107.726829",
      "hostid": 30095,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30095,
      "hostidP": "",
      "end_lat": "29.580191",
      "end_lon": "-107.726829",
      "name_hostC": "F1-Siqura-CHIH01-VVU-IGZA-203",
      "name_hostipC": "10.171.86.195",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.726829",
        "29.580191"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-IGZA-202",
      "latitude": "29.637952",
      "longitude": "-107.755536",
      "hostid": 30092,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30092,
      "hostidP": "",
      "end_lat": "29.637952",
      "end_lon": "-107.755536",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-IGZA-202",
      "name_hostipC": "10.171.86.178",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.755536",
        "29.637952"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-IGZA-202",
      "latitude": "29.637952",
      "longitude": "-107.755536",
      "hostid": 30092,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30092,
      "hostidP": "",
      "end_lat": "29.637952",
      "end_lon": "-107.755536",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-IGZA-202",
      "name_hostipC": "10.171.86.178",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.755536",
        "29.637952"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-Siqura-CHIH01-VVU-IGZA-201",
      "latitude": "29.661805",
      "longitude": "-107.751807",
      "hostid": 30088,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30088,
      "hostidP": "",
      "end_lat": "29.661805",
      "end_lon": "-107.751807",
      "name_hostC": "F2-Siqura-CHIH01-VVU-IGZA-201",
      "name_hostipC": "10.171.86.164",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.751807",
        "29.661805"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-Siqura-CHIH01-VVU-IGZA-201",
      "latitude": "29.661805",
      "longitude": "-107.751807",
      "hostid": 30088,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30088,
      "hostidP": "",
      "end_lat": "29.661805",
      "end_lon": "-107.751807",
      "name_hostC": "F2-Siqura-CHIH01-VVU-IGZA-201",
      "name_hostipC": "10.171.86.164",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.751807",
        "29.661805"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-IGZA-203",
      "latitude": "29.580191",
      "longitude": "-107.726829",
      "hostid": 30238,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30238,
      "hostidP": "",
      "end_lat": "29.580191",
      "end_lon": "-107.726829",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-IGZA-203",
      "name_hostipC": "10.171.86.194",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.726829",
        "29.580191"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-IGZA-203",
      "latitude": "29.580191",
      "longitude": "-107.726829",
      "hostid": 30238,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30238,
      "hostidP": "",
      "end_lat": "29.580191",
      "end_lon": "-107.726829",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-IGZA-203",
      "name_hostipC": "10.171.86.194",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.726829",
        "29.580191"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-JIME-106-SUBCENTRO",
      "latitude": "27.156186",
      "longitude": "-104.889263",
      "hostid": 30257,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30257,
      "hostidP": "",
      "end_lat": "27.156186",
      "end_lon": "-104.889263",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-JIME-106-SUBCENTRO",
      "name_hostipC": "10.171.73.19",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.889263",
        "27.156186"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-JIME-106-SUBCENTRO",
      "latitude": "27.156186",
      "longitude": "-104.889263",
      "hostid": 30257,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30257,
      "hostidP": "",
      "end_lat": "27.156186",
      "end_lon": "-104.889263",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-JIME-106-SUBCENTRO",
      "name_hostipC": "10.171.73.19",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.889263",
        "27.156186"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-JIME-106",
      "latitude": "27.156186",
      "longitude": "-104.889263",
      "hostid": 30117,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30117,
      "hostidP": "",
      "end_lat": "27.156186",
      "end_lon": "-104.889263",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-JIME-106",
      "name_hostipC": "10.171.88.18",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.889263",
        "27.156186"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-JIME-106",
      "latitude": "27.156186",
      "longitude": "-104.889263",
      "hostid": 30117,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30117,
      "hostidP": "",
      "end_lat": "27.156186",
      "end_lon": "-104.889263",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-JIME-106",
      "name_hostipC": "10.171.88.18",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.889263",
        "27.156186"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-ARC-JIME-005-JIMENEZ-SUSCRIPTOR_ARCO",
      "latitude": "27.155673",
      "longitude": "-104.88959",
      "hostid": 31108,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31108,
      "hostidP": "",
      "end_lat": "27.155673",
      "end_lon": "-104.88959",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-ARC-JIME-005-JIMENEZ-SUSCRIPTOR_ARCO",
      "name_hostipC": "10.171.73.21",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.88959",
        "27.155673"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-ARC-JIME-005-JIMENEZ-SUSCRIPTOR_ARCO",
      "latitude": "27.155673",
      "longitude": "-104.88959",
      "hostid": 31108,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31108,
      "hostidP": "",
      "end_lat": "27.155673",
      "end_lon": "-104.88959",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-ARC-JIME-005-JIMENEZ-SUSCRIPTOR_ARCO",
      "name_hostipC": "10.171.73.21",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.88959",
        "27.155673"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-ARC-JIME-004-JIMENEZ-SUSCRIPTOR_ARCO",
      "latitude": "27.117411",
      "longitude": "-104.890625",
      "hostid": 31109,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31109,
      "hostidP": "",
      "end_lat": "27.117411",
      "end_lon": "-104.890625",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-ARC-JIME-004-JIMENEZ-SUSCRIPTOR_ARCO",
      "name_hostipC": "10.171.72.197",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.890625",
        "27.117411"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-ARC-JIME-004-JIMENEZ-SUSCRIPTOR_ARCO",
      "latitude": "27.117411",
      "longitude": "-104.890625",
      "hostid": 31109,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31109,
      "hostidP": "",
      "end_lat": "27.117411",
      "end_lon": "-104.890625",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-ARC-JIME-004-JIMENEZ-SUSCRIPTOR_ARCO",
      "name_hostipC": "10.171.72.197",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.890625",
        "27.117411"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-ESTADISTICAS_OP01-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31420,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31420,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-ESTADISTICAS_OP01-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.141.17",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-ESTADISTICAS_OP01-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31420,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31420,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-ESTADISTICAS_OP01-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.141.17",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-ANALISIS_OP01-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31400,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31400,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-ANALISIS_OP01-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.19",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-ANALISIS_OP01-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31400,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31400,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-ANALISIS_OP01-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.19",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-INTELIGENCIA_OP01-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31402,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31402,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-INTELIGENCIA_OP01-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.6",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-INTELIGENCIA_OP01-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31402,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31402,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-INTELIGENCIA_OP01-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.6",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-MONITOREO_OP05-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31437,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31437,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-MONITOREO_OP05-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.2",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-MONITOREO_OP05-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31437,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31437,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-MONITOREO_OP05-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.2",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-INPLANT-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31428,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31428,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-INPLANT-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.10",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-INPLANT-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31428,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31428,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-INPLANT-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.10",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-ESTADISTICAS_OP02-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31435,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31435,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-ESTADISTICAS_OP02-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.3",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-ESTADISTICAS_OP02-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31435,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31435,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-ESTADISTICAS_OP02-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.3",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-ESTADISTICAS_OP03-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31434,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31434,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-ESTADISTICAS_OP03-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.4",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-ESTADISTICAS_OP03-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31434,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31434,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-ESTADISTICAS_OP03-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.4",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-ASUNTOS_INTERNOS-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31401,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31401,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-ASUNTOS_INTERNOS-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.9",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-ASUNTOS_INTERNOS-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31401,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31401,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-ASUNTOS_INTERNOS-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.9",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-MONITOREO_OP03-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31414,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31414,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-MONITOREO_OP03-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.23",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-MONITOREO_OP03-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31414,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31414,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-MONITOREO_OP03-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.23",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-911_OP2-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31427,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31427,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-911_OP2-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.15",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-911_OP2-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31427,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31427,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-911_OP2-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.15",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-911_OP3-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31404,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31404,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-911_OP3-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.14",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-911_OP3-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31404,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31404,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-911_OP3-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.14",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-MONITOREO_OP04-CHIH01-CMM-DELI-00",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31430,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31430,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-MONITOREO_OP04-CHIH01-CMM-DELI-00",
      "name_hostipC": "10.171.140.20",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-MONITOREO_OP04-CHIH01-CMM-DELI-00",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31430,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31430,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-MONITOREO_OP04-CHIH01-CMM-DELI-00",
      "name_hostipC": "10.171.140.20",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-MONITOREO_OP02-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31409,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31409,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-MONITOREO_OP02-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.24",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-MONITOREO_OP02-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31409,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31409,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-MONITOREO_OP02-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.24",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-INTELIGENCIA_OP02-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31399,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31399,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-INTELIGENCIA_OP02-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.5",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-INTELIGENCIA_OP02-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31399,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31399,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-INTELIGENCIA_OP02-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.5",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-MESA_INTELIGENTE_OP01-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31398,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31398,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-MESA_INTELIGENTE_OP01-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.27",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-MESA_INTELIGENTE_OP01-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31398,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31398,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-MESA_INTELIGENTE_OP01-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.27",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-MONITOREO_OP06-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31416,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31416,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-MONITOREO_OP06-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.18",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WKS-MONITOREO_OP06-CHIH01-CMM-DELI-001",
      "latitude": "28.170553",
      "longitude": "-105.486094",
      "hostid": 31416,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31416,
      "hostidP": "",
      "end_lat": "28.170553",
      "end_lon": "-105.486094",
      "name_hostC": "WKS-MONITOREO_OP06-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.18",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486094",
        "28.170553"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-DELI-138-DELICIAS",
      "latitude": "28.1923416",
      "longitude": "-105.4481841",
      "hostid": 30953,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30953,
      "hostidP": "",
      "end_lat": "28.1923416",
      "end_lon": "-105.4481841",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-DELI-138-DELICIAS",
      "name_hostipC": "10.171.136.126",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.4481841",
        "28.1923416"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-DELI-138-DELICIAS",
      "latitude": "28.1923416",
      "longitude": "-105.4481841",
      "hostid": 30953,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30953,
      "hostidP": "",
      "end_lat": "28.1923416",
      "end_lon": "-105.4481841",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-DELI-138-DELICIAS",
      "name_hostipC": "10.171.136.126",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.4481841",
        "28.1923416"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "ACCESSPOINT-EWC-CISCO-CHIH01-CMM-JIME-001",
      "latitude": "28.6678687",
      "longitude": "-106.0355854",
      "hostid": 31309,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31309,
      "hostidP": "",
      "end_lat": "28.6678687",
      "end_lon": "-106.0355854",
      "name_hostC": "ACCESSPOINT-EWC-CISCO-CHIH01-CMM-JIME-001",
      "name_hostipC": "10.171.65.217",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.0355854",
        "28.6678687"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "ACCESSPOINT-EWC-CISCO-CHIH01-CMM-JIME-001",
      "latitude": "28.6678687",
      "longitude": "-106.0355854",
      "hostid": 31309,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31309,
      "hostidP": "",
      "end_lat": "28.6678687",
      "end_lon": "-106.0355854",
      "name_hostC": "ACCESSPOINT-EWC-CISCO-CHIH01-CMM-JIME-001",
      "name_hostipC": "10.171.65.217",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.0355854",
        "28.6678687"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-911_OP4-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31733,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31733,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-911_OP4-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.26",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-911_OP4-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31733,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31733,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-911_OP4-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.26",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-911_OP1-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31704,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31704,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-911_OP1-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.23",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-911_OP1-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31704,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31704,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-911_OP1-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.23",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-SALA-JUNTAS-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31707,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31707,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-SALA-JUNTAS-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.22",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-SALA-JUNTAS-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31707,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31707,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-SALA-JUNTAS-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.22",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MONITOREO_OP1-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31692,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31692,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MONITOREO_OP1-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.2",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MONITOREO_OP1-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31692,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31692,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MONITOREO_OP1-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.2",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ESTADISTICA_OP2-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31680,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31680,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-ESTADISTICA_OP2-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.33",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ESTADISTICA_OP2-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31680,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31680,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-ESTADISTICA_OP2-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.33",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-911_OP3-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31674,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31674,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-911_OP3-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.25",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-911_OP3-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31674,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31674,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-911_OP3-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.25",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ASUNTOS-INTERNOS-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31723,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31723,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-ASUNTOS-INTERNOS-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.31",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ASUNTOS-INTERNOS-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31723,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31723,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-ASUNTOS-INTERNOS-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.31",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-RECEPCION-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31673,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31673,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-RECEPCION-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.41",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-RECEPCION-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31673,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31673,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-RECEPCION-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.41",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MONITOREO_OP7-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31703,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31703,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MONITOREO_OP7-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.10",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MONITOREO_OP7-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31703,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31703,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MONITOREO_OP7-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.10",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "BIOMETRICO-RECEPCION-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31708,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31708,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "BIOMETRICO-RECEPCION-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.17",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "BIOMETRICO-RECEPCION-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31708,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31708,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "BIOMETRICO-RECEPCION-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.17",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-INTELIGENCIA_OP1-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31686,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31686,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-INTELIGENCIA_OP1-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.27",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-INTELIGENCIA_OP1-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31686,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31686,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-INTELIGENCIA_OP1-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.27",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MONITOREO_OP8-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31709,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31709,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MONITOREO_OP8-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.11",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MONITOREO_OP8-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31709,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31709,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MONITOREO_OP8-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.11",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ANALISIS_OP2-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31684,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31684,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-ANALISIS_OP2-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.37",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ANALISIS_OP2-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31684,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31684,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-ANALISIS_OP2-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.37",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ANALISIS_OP1-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31683,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31683,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-ANALISIS_OP1-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.38",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ANALISIS_OP1-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31683,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31683,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-ANALISIS_OP1-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.38",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MESA-INTELIGENTE_OP1-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31678,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31678,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MESA-INTELIGENTE_OP1-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.7",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MESA-INTELIGENTE_OP1-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31678,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31678,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MESA-INTELIGENTE_OP1-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.7",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MONITOREO_OP11-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31706,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31706,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MONITOREO_OP11-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.14",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MONITOREO_OP11-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31706,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31706,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MONITOREO_OP11-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.14",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MONITOREO_OP4-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31671,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31671,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MONITOREO_OP4-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.5",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MONITOREO_OP4-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31671,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31671,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MONITOREO_OP4-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.5",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ESTADISTICA_OP3-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31714,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31714,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-ESTADISTICA_OP3-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.35",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ESTADISTICA_OP3-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31714,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31714,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-ESTADISTICA_OP3-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.35",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-INTELIGENCIA_OP2-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31696,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31696,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-INTELIGENCIA_OP2-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.28",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-INTELIGENCIA_OP2-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31696,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31696,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-INTELIGENCIA_OP2-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.28",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "BIOMETRICO-MONITOREO-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31713,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31713,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "BIOMETRICO-MONITOREO-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.18",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "BIOMETRICO-MONITOREO-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31713,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31713,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "BIOMETRICO-MONITOREO-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.18",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-911_OP2-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31736,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31736,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-911_OP2-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.24",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-911_OP2-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31736,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31736,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-911_OP2-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.24",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MONITOREO_OP9-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31722,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31722,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MONITOREO_OP9-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.12",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MONITOREO_OP9-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31722,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31722,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MONITOREO_OP9-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.12",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "BIOMETRICO-SITE-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31735,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31735,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "BIOMETRICO-SITE-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.16",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "BIOMETRICO-SITE-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31735,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31735,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "BIOMETRICO-SITE-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.16",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MESA-INTELIGENTE_OP2-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31725,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31725,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MESA-INTELIGENTE_OP2-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.8",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MESA-INTELIGENTE_OP2-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31725,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31725,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MESA-INTELIGENTE_OP2-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.8",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ESTADISTICA_OP1-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31694,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31694,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-ESTADISTICA_OP1-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.34",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ESTADISTICA_OP1-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31694,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31694,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-ESTADISTICA_OP1-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.34",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-INTELIGENCIA_OP4-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31727,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31727,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-INTELIGENCIA_OP4-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.30",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-INTELIGENCIA_OP4-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31727,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31727,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-INTELIGENCIA_OP4-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.30",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-INTELIGENCIA_OP3-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31681,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31681,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-INTELIGENCIA_OP3-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.29",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-INTELIGENCIA_OP3-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31681,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31681,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-INTELIGENCIA_OP3-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.29",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MONITOREO_OP10-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31710,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31710,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MONITOREO_OP10-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.13",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MONITOREO_OP10-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31710,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31710,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-MONITOREO_OP10-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.13",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ESTADISTICA_OP4-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31726,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31726,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-ESTADISTICA_OP4-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.36",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ESTADISTICA_OP4-CHIH01-CMM-HIPA-001",
      "latitude": "26.9271",
      "longitude": "-105.671",
      "hostid": 31726,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31726,
      "hostidP": "",
      "end_lat": "26.9271",
      "end_lon": "-105.671",
      "name_hostC": "WRK-ESTADISTICA_OP4-CHIH01-CMM-HIPA-001",
      "name_hostipC": "10.171.60.36",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.671",
        "26.9271"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR02-VVU-AXIS-P1465-LE-CHIH01-VVU-HIPA-105",
      "latitude": "26.939237",
      "longitude": "-105.691614",
      "hostid": 23477,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 23477,
      "hostidP": "",
      "end_lat": "26.939237",
      "end_lon": "-105.691614",
      "name_hostC": "LPR02-VVU-AXIS-P1465-LE-CHIH01-VVU-HIPA-105",
      "name_hostipC": "10.171.48.70",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.691614",
        "26.939237"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR02-VVU-AXIS-P1465-LE-CHIH01-VVU-HIPA-105",
      "latitude": "26.939237",
      "longitude": "-105.691614",
      "hostid": 23477,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 23477,
      "hostidP": "",
      "end_lat": "26.939237",
      "end_lon": "-105.691614",
      "name_hostC": "LPR02-VVU-AXIS-P1465-LE-CHIH01-VVU-HIPA-105",
      "name_hostipC": "10.171.48.70",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.691614",
        "26.939237"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-147-CUAUHTEMOC-TEC",
      "latitude": "28.448048",
      "longitude": "-106.911722",
      "hostid": 31797,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31797,
      "hostidP": "",
      "end_lat": "28.448048",
      "end_lon": "-106.911722",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-147-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.184",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.911722",
        "28.448048"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-147-CUAUHTEMOC-TEC",
      "latitude": "28.448048",
      "longitude": "-106.911722",
      "hostid": 31797,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31797,
      "hostidP": "",
      "end_lat": "28.448048",
      "end_lon": "-106.911722",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-147-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.184",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.911722",
        "28.448048"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-010-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.4811",
      "longitude": "-106.73579",
      "hostid": 31818,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31818,
      "hostidP": "",
      "end_lat": "28.4811",
      "end_lon": "-106.73579",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-010-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.89",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.73579",
        "28.4811"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-010-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.4811",
      "longitude": "-106.73579",
      "hostid": 31818,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31818,
      "hostidP": "",
      "end_lat": "28.4811",
      "end_lon": "-106.73579",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-010-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.89",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.73579",
        "28.4811"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-BACH-191-CUAUHTEMOC",
      "latitude": "28.7825274",
      "longitude": "-107.2623539",
      "hostid": 31791,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31791,
      "hostidP": "",
      "end_lat": "28.7825274",
      "end_lon": "-107.2623539",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-BACH-191-CUAUHTEMOC",
      "name_hostipC": "10.171.220.19",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.2623539",
        "28.7825274"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-BACH-191-CUAUHTEMOC",
      "latitude": "28.7825274",
      "longitude": "-107.2623539",
      "hostid": 31791,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31791,
      "hostidP": "",
      "end_lat": "28.7825274",
      "end_lon": "-107.2623539",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-BACH-191-CUAUHTEMOC",
      "name_hostipC": "10.171.220.19",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.2623539",
        "28.7825274"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-CUAU-146-CUAUHTEMOC",
      "latitude": "28.457646",
      "longitude": "-106.911751",
      "hostid": 31761,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31761,
      "hostidP": "",
      "end_lat": "28.457646",
      "end_lon": "-106.911751",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-CUAU-146-CUAUHTEMOC",
      "name_hostipC": "10.171.42.183",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.911751",
        "28.457646"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-CUAU-146-CUAUHTEMOC",
      "latitude": "28.457646",
      "longitude": "-106.911751",
      "hostid": 31761,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31761,
      "hostidP": "",
      "end_lat": "28.457646",
      "end_lon": "-106.911751",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-CUAU-146-CUAUHTEMOC",
      "name_hostipC": "10.171.42.183",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.911751",
        "28.457646"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-OCAM-193-CUAUHTEMOC",
      "latitude": "28.7825274",
      "longitude": "-107.2623539",
      "hostid": 31776,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31776,
      "hostidP": "",
      "end_lat": "28.7825274",
      "end_lon": "-107.2623539",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-OCAM-193-CUAUHTEMOC",
      "name_hostipC": "10.171.220.59",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.2623539",
        "28.7825274"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-OCAM-193-CUAUHTEMOC",
      "latitude": "28.7825274",
      "longitude": "-107.2623539",
      "hostid": 31776,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31776,
      "hostidP": "",
      "end_lat": "28.7825274",
      "end_lon": "-107.2623539",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-OCAM-193-CUAUHTEMOC",
      "name_hostipC": "10.171.220.59",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.2623539",
        "28.7825274"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-171-CHIHUAHUA-SEECH",
      "latitude": "28.643748",
      "longitude": "-106.146211",
      "hostid": 31905,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31905,
      "hostidP": "",
      "end_lat": "28.643748",
      "end_lon": "-106.146211",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-171-CHIHUAHUA-SEECH",
      "name_hostipC": "10.171.128.16",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.146211",
        "28.643748"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-171-CHIHUAHUA-SEECH",
      "latitude": "28.643748",
      "longitude": "-106.146211",
      "hostid": 31905,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31905,
      "hostidP": "",
      "end_lat": "28.643748",
      "end_lon": "-106.146211",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-171-CHIHUAHUA-SEECH",
      "name_hostipC": "10.171.128.16",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.146211",
        "28.643748"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-ALDA-013-CHIHUAHUA-RR_ALDAMA",
      "latitude": "28.862728",
      "longitude": "-105.939392",
      "hostid": 31890,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31890,
      "hostidP": "",
      "end_lat": "28.862728",
      "end_lon": "-105.939392",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-ALDA-013-CHIHUAHUA-RR_ALDAMA",
      "name_hostipC": "10.171.115.75",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.939392",
        "28.862728"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-ALDA-013-CHIHUAHUA-RR_ALDAMA",
      "latitude": "28.862728",
      "longitude": "-105.939392",
      "hostid": 31890,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31890,
      "hostidP": "",
      "end_lat": "28.862728",
      "end_lon": "-105.939392",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-ALDA-013-CHIHUAHUA-RR_ALDAMA",
      "name_hostipC": "10.171.115.75",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.939392",
        "28.862728"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-Siqura-CHIH01-VVU-CUAU-076-CUAUHTEMOC",
      "latitude": "28.541806",
      "longitude": "-106.912054",
      "hostid": 31975,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31975,
      "hostidP": "",
      "end_lat": "28.541806",
      "end_lon": "-106.912054",
      "name_hostC": "F2-Siqura-CHIH01-VVU-CUAU-076-CUAUHTEMOC",
      "name_hostipC": "10.171.150.13",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912054",
        "28.541806"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-Siqura-CHIH01-VVU-CUAU-076-CUAUHTEMOC",
      "latitude": "28.541806",
      "longitude": "-106.912054",
      "hostid": 31975,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31975,
      "hostidP": "",
      "end_lat": "28.541806",
      "end_lon": "-106.912054",
      "name_hostC": "F2-Siqura-CHIH01-VVU-CUAU-076-CUAUHTEMOC",
      "name_hostipC": "10.171.150.13",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912054",
        "28.541806"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-013-CUAUHTEMOC-TEC",
      "latitude": "28.4944461",
      "longitude": "-106.9120758",
      "hostid": 31983,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31983,
      "hostidP": "",
      "end_lat": "28.4944461",
      "end_lon": "-106.9120758",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-013-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.224",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.9120758",
        "28.4944461"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-013-CUAUHTEMOC-TEC",
      "latitude": "28.4944461",
      "longitude": "-106.9120758",
      "hostid": 31983,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31983,
      "hostidP": "",
      "end_lat": "28.4944461",
      "end_lon": "-106.9120758",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-013-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.224",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.9120758",
        "28.4944461"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-CRUM-OP3-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32022,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32022,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-CRUM-OP3-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.15",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-CRUM-OP3-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32022,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32022,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-CRUM-OP3-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.15",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-DEFENSA-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32046,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32046,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-DEFENSA-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.11",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-DEFENSA-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32046,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32046,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-DEFENSA-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.11",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-CRUM-OP4-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32013,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32013,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-CRUM-OP4-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.14",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-CRUM-OP4-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32013,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32013,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-CRUM-OP4-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.14",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ANALISIS-Y-ESTADISTICAS-OP2-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32037,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32037,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-ANALISIS-Y-ESTADISTICAS-OP2-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.55",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ANALISIS-Y-ESTADISTICAS-OP2-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32037,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32037,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-ANALISIS-Y-ESTADISTICAS-OP2-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.55",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-SALA-DE-JUNTAS-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32020,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32020,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-SALA-DE-JUNTAS-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.29",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-SALA-DE-JUNTAS-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32020,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32020,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-SALA-DE-JUNTAS-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.29",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MESA-INTELIGENTE-OP1-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32026,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32026,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-MESA-INTELIGENTE-OP1-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.13",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MESA-INTELIGENTE-OP1-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32026,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32026,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-MESA-INTELIGENTE-OP1-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.13",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-INTELIGENCIA-OP4-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32042,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32042,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-INTELIGENCIA-OP4-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.26",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-INTELIGENCIA-OP4-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32042,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32042,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-INTELIGENCIA-OP4-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.26",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ANALISIS-Y-ESTADISTICAS-OP1-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32021,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32021,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-ANALISIS-Y-ESTADISTICAS-OP1-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.22",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ANALISIS-Y-ESTADISTICAS-OP1-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32021,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32021,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-ANALISIS-Y-ESTADISTICAS-OP1-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.22",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-CRUM-OP6-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32045,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32045,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-CRUM-OP6-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.17",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-CRUM-OP6-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32045,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32045,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-CRUM-OP6-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.17",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ANALISIS-Y-ESTADISTICAS-O4-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32010,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32010,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-ANALISIS-Y-ESTADISTICAS-O4-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.57",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ANALISIS-Y-ESTADISTICAS-O4-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32010,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32010,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-ANALISIS-Y-ESTADISTICAS-O4-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.57",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-TRANSITO-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32036,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32036,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-TRANSITO-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.7",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-TRANSITO-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32036,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32036,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-TRANSITO-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.7",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-INTELIGENCIA-OP1-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32038,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32038,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-INTELIGENCIA-OP1-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.23",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-INTELIGENCIA-OP1-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32038,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32038,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-INTELIGENCIA-OP1-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.23",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ANALISIS-Y-ESTADISTICAS-O3-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 31998,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31998,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-ANALISIS-Y-ESTADISTICAS-O3-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.56",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-ANALISIS-Y-ESTADISTICAS-O3-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 31998,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31998,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-ANALISIS-Y-ESTADISTICAS-O3-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.56",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MESA-INTELIGENTE-OP2-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32002,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32002,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-MESA-INTELIGENTE-OP2-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.12",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-MESA-INTELIGENTE-OP2-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32002,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32002,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-MESA-INTELIGENTE-OP2-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.12",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-INTELIGENCIA-OP2-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32034,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32034,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-INTELIGENCIA-OP2-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.24",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-INTELIGENCIA-OP2-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32034,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32034,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-INTELIGENCIA-OP2-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.24",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-CRUM-OP1-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32033,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32033,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-CRUM-OP1-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.19",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-CRUM-OP1-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32033,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32033,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-CRUM-OP1-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.19",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-CRUZ-ROJA-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32030,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32030,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-CRUZ-ROJA-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.34",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "WRK-CRUZ-ROJA-CHIH01-CMM-CUAU-001",
      "latitude": "28.403443",
      "longitude": "-106.854136",
      "hostid": 32030,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32030,
      "hostidP": "",
      "end_lat": "28.403443",
      "end_lon": "-106.854136",
      "name_hostC": "WRK-CRUZ-ROJA-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.34",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.854136",
        "28.403443"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-077-CUAUHTEMOC-R.R.ALVARO_OBREGON",
      "latitude": "28.601471",
      "longitude": "-106.912374",
      "hostid": 32066,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32066,
      "hostidP": "",
      "end_lat": "28.601471",
      "end_lon": "-106.912374",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-077-CUAUHTEMOC-R.R.ALVARO_OBREGON",
      "name_hostipC": "10.171.152.177",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912374",
        "28.601471"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-077-CUAUHTEMOC-R.R.ALVARO_OBREGON",
      "latitude": "28.601471",
      "longitude": "-106.912374",
      "hostid": 32066,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32066,
      "hostidP": "",
      "end_lat": "28.601471",
      "end_lon": "-106.912374",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-077-CUAUHTEMOC-R.R.ALVARO_OBREGON",
      "name_hostipC": "10.171.152.177",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912374",
        "28.601471"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CDJU-1005-JUAREZ-NIM15",
      "latitude": "31.605794",
      "longitude": "-106.397958",
      "hostid": 32125,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32125,
      "hostidP": "",
      "end_lat": "31.605794",
      "end_lon": "-106.397958",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CDJU-1005-JUAREZ-NIM15",
      "name_hostipC": "10.169.6.29",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.397958",
        "31.605794"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CDJU-1005-JUAREZ-NIM15",
      "latitude": "31.605794",
      "longitude": "-106.397958",
      "hostid": 32125,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32125,
      "hostidP": "",
      "end_lat": "31.605794",
      "end_lon": "-106.397958",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CDJU-1005-JUAREZ-NIM15",
      "name_hostipC": "10.169.6.29",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.397958",
        "31.605794"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CDJU-1011-JUAREZ-NIM15",
      "latitude": "31.638285",
      "longitude": "-106.369847",
      "hostid": 32157,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32157,
      "hostidP": "",
      "end_lat": "31.638285",
      "end_lon": "-106.369847",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CDJU-1011-JUAREZ-NIM15",
      "name_hostipC": "10.169.6.205",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.369847",
        "31.638285"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CDJU-1011-JUAREZ-NIM15",
      "latitude": "31.638285",
      "longitude": "-106.369847",
      "hostid": 32157,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32157,
      "hostidP": "",
      "end_lat": "31.638285",
      "end_lon": "-106.369847",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CDJU-1011-JUAREZ-NIM15",
      "name_hostipC": "10.169.6.205",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.369847",
        "31.638285"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CDJU-957-JUAREZ-NIM4",
      "latitude": "31.710197",
      "longitude": "-106.458522",
      "hostid": 32134,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32134,
      "hostidP": "",
      "end_lat": "31.710197",
      "end_lon": "-106.458522",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CDJU-957-JUAREZ-NIM4",
      "name_hostipC": "10.171.27.98",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.458522",
        "31.710197"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CDJU-957-JUAREZ-NIM4",
      "latitude": "31.710197",
      "longitude": "-106.458522",
      "hostid": 32134,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32134,
      "hostidP": "",
      "end_lat": "31.710197",
      "end_lon": "-106.458522",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CDJU-957-JUAREZ-NIM4",
      "name_hostipC": "10.171.27.98",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.458522",
        "31.710197"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-226-CUAUHTEMOC-COBACH14",
      "latitude": "28.451359",
      "longitude": "-106.789942",
      "hostid": 32053,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32053,
      "hostidP": "",
      "end_lat": "28.451359",
      "end_lon": "-106.789942",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-226-CUAUHTEMOC-COBACH14",
      "name_hostipC": "10.171.42.8",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.789942",
        "28.451359"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-226-CUAUHTEMOC-COBACH14",
      "latitude": "28.451359",
      "longitude": "-106.789942",
      "hostid": 32053,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32053,
      "hostidP": "",
      "end_lat": "28.451359",
      "end_lon": "-106.789942",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-226-CUAUHTEMOC-COBACH14",
      "name_hostipC": "10.171.42.8",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.789942",
        "28.451359"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-TELMEX-CHIH01-CMM-CAMA-001",
      "latitude": "27.669522",
      "longitude": "-105.16929",
      "hostid": 32174,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32174,
      "hostidP": "",
      "end_lat": "27.669522",
      "end_lon": "-105.16929",
      "name_hostC": "SWITCH-TELMEX-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.37.158",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.16929",
        "27.669522"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-TELMEX-CHIH01-CMM-CAMA-001",
      "latitude": "27.669522",
      "longitude": "-105.16929",
      "hostid": 32174,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32174,
      "hostidP": "",
      "end_lat": "27.669522",
      "end_lon": "-105.16929",
      "name_hostC": "SWITCH-TELMEX-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.37.158",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.16929",
        "27.669522"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-TELMEX-CHIH01-CMM-DELI-001",
      "latitude": "28.1706",
      "longitude": "-105.486",
      "hostid": 32169,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32169,
      "hostidP": "",
      "end_lat": "28.1706",
      "end_lon": "-105.486",
      "name_hostC": "SWITCH-TELMEX-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.190",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486",
        "28.1706"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-TELMEX-CHIH01-CMM-DELI-001",
      "latitude": "28.1706",
      "longitude": "-105.486",
      "hostid": 32169,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32169,
      "hostidP": "",
      "end_lat": "28.1706",
      "end_lon": "-105.486",
      "name_hostC": "SWITCH-TELMEX-CHIH01-CMM-DELI-001",
      "name_hostipC": "10.171.140.190",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.486",
        "28.1706"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-TELMEX-CHIH01-CMM-CUAU-001",
      "latitude": "28.403561",
      "longitude": "-106.85414",
      "hostid": 32170,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32170,
      "hostidP": "",
      "end_lat": "28.403561",
      "end_lon": "-106.85414",
      "name_hostC": "SWITCH-TELMEX-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.190",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.85414",
        "28.403561"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-TELMEX-CHIH01-CMM-CUAU-001",
      "latitude": "28.403561",
      "longitude": "-106.85414",
      "hostid": 32170,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32170,
      "hostidP": "",
      "end_lat": "28.403561",
      "end_lon": "-106.85414",
      "name_hostC": "SWITCH-TELMEX-CHIH01-CMM-CUAU-001",
      "name_hostipC": "10.171.101.190",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.85414",
        "28.403561"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-TELMEX-CHIH01-CMM-JIME-001",
      "latitude": "27.132059",
      "longitude": "-104.9065",
      "hostid": 32166,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32166,
      "hostidP": "",
      "end_lat": "27.132059",
      "end_lon": "-104.9065",
      "name_hostC": "SWITCH-TELMEX-CHIH01-CMM-JIME-001",
      "name_hostipC": "10.171.65.190",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.9065",
        "27.132059"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-TELMEX-CHIH01-CMM-JIME-001",
      "latitude": "27.132059",
      "longitude": "-104.9065",
      "hostid": 32166,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32166,
      "hostidP": "",
      "end_lat": "27.132059",
      "end_lon": "-104.9065",
      "name_hostC": "SWITCH-TELMEX-CHIH01-CMM-JIME-001",
      "name_hostipC": "10.171.65.190",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.9065",
        "27.132059"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-TELMEX-CHIH01-CMM-BOCO-001",
      "latitude": "27.76379",
      "longitude": "-107.631",
      "hostid": 32171,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32171,
      "hostidP": "",
      "end_lat": "27.76379",
      "end_lon": "-107.631",
      "name_hostC": "SWITCH-TELMEX-CHIH01-CMM-BOCO-001",
      "name_hostipC": "10.171.190.216",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.631",
        "27.76379"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-TELMEX-CHIH01-CMM-BOCO-001",
      "latitude": "27.76379",
      "longitude": "-107.631",
      "hostid": 32171,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32171,
      "hostidP": "",
      "end_lat": "27.76379",
      "end_lon": "-107.631",
      "name_hostC": "SWITCH-TELMEX-CHIH01-CMM-BOCO-001",
      "name_hostipC": "10.171.190.216",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.631",
        "27.76379"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-101-CUAUHTEMOC-R.R_ALVARO_OBREGON",
      "latitude": "28.711685",
      "longitude": "-106.912801",
      "hostid": 32207,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32207,
      "hostidP": "",
      "end_lat": "28.711685",
      "end_lon": "-106.912801",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-101-CUAUHTEMOC-R.R_ALVARO_OBREGON",
      "name_hostipC": "10.171.152.161",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912801",
        "28.711685"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-101-CUAUHTEMOC-R.R_ALVARO_OBREGON",
      "latitude": "28.711685",
      "longitude": "-106.912801",
      "hostid": 32207,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32207,
      "hostidP": "",
      "end_lat": "28.711685",
      "end_lon": "-106.912801",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-101-CUAUHTEMOC-R.R_ALVARO_OBREGON",
      "name_hostipC": "10.171.152.161",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912801",
        "28.711685"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-SIQURA-CHIH01-VVU-GUER-266",
      "latitude": "28.563317",
      "longitude": "-107.503671",
      "hostid": 32052,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32052,
      "hostidP": "",
      "end_lat": "28.563317",
      "end_lon": "-107.503671",
      "name_hostC": "PTZ-SIQURA-CHIH01-VVU-GUER-266",
      "name_hostipC": "10.171.89.178",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.503671",
        "28.563317"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-SIQURA-CHIH01-VVU-GUER-266",
      "latitude": "28.563317",
      "longitude": "-107.503671",
      "hostid": 32052,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32052,
      "hostidP": "",
      "end_lat": "28.563317",
      "end_lon": "-107.503671",
      "name_hostC": "PTZ-SIQURA-CHIH01-VVU-GUER-266",
      "name_hostipC": "10.171.89.178",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.503671",
        "28.563317"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-SIQURA-CHIH01-VVU-GUER-266",
      "latitude": "28.563317",
      "longitude": "-107.503671",
      "hostid": 32057,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32057,
      "hostidP": "",
      "end_lat": "28.563317",
      "end_lon": "-107.503671",
      "name_hostC": "F2-SIQURA-CHIH01-VVU-GUER-266",
      "name_hostipC": "10.171.89.180",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.503671",
        "28.563317"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-SIQURA-CHIH01-VVU-GUER-266",
      "latitude": "28.563317",
      "longitude": "-107.503671",
      "hostid": 32057,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32057,
      "hostidP": "",
      "end_lat": "28.563317",
      "end_lon": "-107.503671",
      "name_hostC": "F2-SIQURA-CHIH01-VVU-GUER-266",
      "name_hostipC": "10.171.89.180",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.503671",
        "28.563317"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-SIQURA-CHIH01-VVU-GUER-266",
      "latitude": "28.563317",
      "longitude": "-107.503671",
      "hostid": 32059,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32059,
      "hostidP": "",
      "end_lat": "28.563317",
      "end_lon": "-107.503671",
      "name_hostC": "F1-SIQURA-CHIH01-VVU-GUER-266",
      "name_hostipC": "10.171.89.179",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.503671",
        "28.563317"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-SIQURA-CHIH01-VVU-GUER-266",
      "latitude": "28.563317",
      "longitude": "-107.503671",
      "hostid": 32059,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32059,
      "hostidP": "",
      "end_lat": "28.563317",
      "end_lon": "-107.503671",
      "name_hostC": "F1-SIQURA-CHIH01-VVU-GUER-266",
      "name_hostipC": "10.171.89.179",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.503671",
        "28.563317"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-GUER-266",
      "latitude": "28.563317",
      "longitude": "-107.503671",
      "hostid": 32048,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32048,
      "hostidP": "",
      "end_lat": "28.563317",
      "end_lon": "-107.503671",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-GUER-266",
      "name_hostipC": "10.171.174.180",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.503671",
        "28.563317"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-GUER-266",
      "latitude": "28.563317",
      "longitude": "-107.503671",
      "hostid": 32048,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32048,
      "hostidP": "",
      "end_lat": "28.563317",
      "end_lon": "-107.503671",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-GUER-266",
      "name_hostipC": "10.171.174.180",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.503671",
        "28.563317"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-CORO-099-JIMENEZ",
      "latitude": "26.74171",
      "longitude": "-105.16351",
      "hostid": 32342,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32342,
      "hostidP": "",
      "end_lat": "26.74171",
      "end_lon": "-105.16351",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-CORO-099-JIMENEZ",
      "name_hostipC": "10.171.210.131",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.16351",
        "26.74171"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-CORO-099-JIMENEZ",
      "latitude": "26.74171",
      "longitude": "-105.16351",
      "hostid": 32342,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32342,
      "hostidP": "",
      "end_lat": "26.74171",
      "end_lon": "-105.16351",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-CORO-099-JIMENEZ",
      "name_hostipC": "10.171.210.131",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.16351",
        "26.74171"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-CORO-101-JIMENEZ",
      "latitude": "26.737410",
      "longitude": "-105.157933",
      "hostid": 32343,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32343,
      "hostidP": "",
      "end_lat": "26.737410",
      "end_lon": "-105.157933",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-CORO-101-JIMENEZ",
      "name_hostipC": "10.171.210.147",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.157933",
        "26.737410"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-CORO-101-JIMENEZ",
      "latitude": "26.737410",
      "longitude": "-105.157933",
      "hostid": 32343,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32343,
      "hostidP": "",
      "end_lat": "26.737410",
      "end_lon": "-105.157933",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-CORO-101-JIMENEZ",
      "name_hostipC": "10.171.210.147",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.157933",
        "26.737410"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-GUER-004",
      "latitude": "28.563157",
      "longitude": "-107.503443",
      "hostid": 32054,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32054,
      "hostidP": "",
      "end_lat": "28.563157",
      "end_lon": "-107.503443",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-GUER-004",
      "name_hostipC": "10.171.74.182",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.503443",
        "28.563157"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-GUER-004",
      "latitude": "28.563157",
      "longitude": "-107.503443",
      "hostid": 32054,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32054,
      "hostidP": "",
      "end_lat": "28.563157",
      "end_lon": "-107.503443",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-GUER-004",
      "name_hostipC": "10.171.74.182",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.503443",
        "28.563157"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-CUAU-169-CUAUHTEMOC",
      "latitude": "28.412376",
      "longitude": "-106.856584",
      "hostid": 32089,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32089,
      "hostidP": "",
      "end_lat": "28.412376",
      "end_lon": "-106.856584",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-CUAU-169-CUAUHTEMOC",
      "name_hostipC": "10.169.119.106",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.856584",
        "28.412376"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-CUAU-169-CUAUHTEMOC",
      "latitude": "28.412376",
      "longitude": "-106.856584",
      "hostid": 32089,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32089,
      "hostidP": "",
      "end_lat": "28.412376",
      "end_lon": "-106.856584",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-CUAU-169-CUAUHTEMOC",
      "name_hostipC": "10.169.119.106",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.856584",
        "28.412376"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-CUAU-167-CUAUHTEMOC",
      "latitude": "28.412114",
      "longitude": "-106.875792",
      "hostid": 32087,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32087,
      "hostidP": "",
      "end_lat": "28.412114",
      "end_lon": "-106.875792",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-CUAU-167-CUAUHTEMOC",
      "name_hostipC": "10.169.118.246",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.875792",
        "28.412114"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-CUAU-167-CUAUHTEMOC",
      "latitude": "28.412114",
      "longitude": "-106.875792",
      "hostid": 32087,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32087,
      "hostidP": "",
      "end_lat": "28.412114",
      "end_lon": "-106.875792",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-CUAU-167-CUAUHTEMOC",
      "name_hostipC": "10.169.118.246",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.875792",
        "28.412114"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-CUAU-169-CUAUHTEMOC",
      "latitude": "28.412376",
      "longitude": "-106.856584",
      "hostid": 32084,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32084,
      "hostidP": "",
      "end_lat": "28.412376",
      "end_lon": "-106.856584",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-CUAU-169-CUAUHTEMOC",
      "name_hostipC": "10.169.119.99",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.856584",
        "28.412376"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-CUAU-169-CUAUHTEMOC",
      "latitude": "28.412376",
      "longitude": "-106.856584",
      "hostid": 32084,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 32084,
      "hostidP": "",
      "end_lat": "28.412376",
      "end_lon": "-106.856584",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-CUAU-169-CUAUHTEMOC",
      "name_hostipC": "10.169.119.99",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.856584",
        "28.412376"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "TEL-ESTADISTICA_OP4-CHIH01-CMM-CAMA-001",
      "latitude": "27.669374",
      "longitude": "-105.169184",
      "hostid": 30736,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30736,
      "hostidP": "",
      "end_lat": "27.669374",
      "end_lon": "-105.169184",
      "name_hostC": "TEL-ESTADISTICA_OP4-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.37.147",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.169184",
        "27.669374"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "TEL-ESTADISTICA_OP4-CHIH01-CMM-CAMA-001",
      "latitude": "27.669374",
      "longitude": "-105.169184",
      "hostid": 30736,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30736,
      "hostidP": "",
      "end_lat": "27.669374",
      "end_lon": "-105.169184",
      "name_hostC": "TEL-ESTADISTICA_OP4-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.37.147",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.169184",
        "27.669374"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "TEL-ESTADISTICA_OP1-CHIH01-CMM-CAMA-001",
      "latitude": "27.669374",
      "longitude": "-105.169184",
      "hostid": 30738,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30738,
      "hostidP": "",
      "end_lat": "27.669374",
      "end_lon": "-105.169184",
      "name_hostC": "TEL-ESTADISTICA_OP1-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.37.143",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.169184",
        "27.669374"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "TEL-ESTADISTICA_OP1-CHIH01-CMM-CAMA-001",
      "latitude": "27.669374",
      "longitude": "-105.169184",
      "hostid": 30738,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30738,
      "hostidP": "",
      "end_lat": "27.669374",
      "end_lon": "-105.169184",
      "name_hostC": "TEL-ESTADISTICA_OP1-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.37.143",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.169184",
        "27.669374"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "TEL-ESTADISTICA_OP3-CHIH01-CMM-CAMA-001",
      "latitude": "27.669374",
      "longitude": "-105.169184",
      "hostid": 30741,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30741,
      "hostidP": "",
      "end_lat": "27.669374",
      "end_lon": "-105.169184",
      "name_hostC": "TEL-ESTADISTICA_OP3-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.37.146",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.169184",
        "27.669374"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "TEL-ESTADISTICA_OP3-CHIH01-CMM-CAMA-001",
      "latitude": "27.669374",
      "longitude": "-105.169184",
      "hostid": 30741,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30741,
      "hostidP": "",
      "end_lat": "27.669374",
      "end_lon": "-105.169184",
      "name_hostC": "TEL-ESTADISTICA_OP3-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.37.146",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.169184",
        "27.669374"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "TEL-ANALISIS_OP1-CHIH01-CMM-CAMA-001",
      "latitude": "27.669374",
      "longitude": "-105.169184",
      "hostid": 30760,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30760,
      "hostidP": "",
      "end_lat": "27.669374",
      "end_lon": "-105.169184",
      "name_hostC": "TEL-ANALISIS_OP1-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.37.151",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.169184",
        "27.669374"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "TEL-ANALISIS_OP1-CHIH01-CMM-CAMA-001",
      "latitude": "27.669374",
      "longitude": "-105.169184",
      "hostid": 30760,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30760,
      "hostidP": "",
      "end_lat": "27.669374",
      "end_lon": "-105.169184",
      "name_hostC": "TEL-ANALISIS_OP1-CHIH01-CMM-CAMA-001",
      "name_hostipC": "10.171.37.151",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.169184",
        "27.669374"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-CUAU-016-CUAUHTEMOC",
      "latitude": "28.653146",
      "longitude": "-106.912499",
      "hostid": 31990,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31990,
      "hostidP": "",
      "end_lat": "28.653146",
      "end_lon": "-106.912499",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-CUAU-016-CUAUHTEMOC",
      "name_hostipC": "10.171.152.172",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912499",
        "28.653146"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-CUAU-016-CUAUHTEMOC",
      "latitude": "28.653146",
      "longitude": "-106.912499",
      "hostid": 31990,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31990,
      "hostidP": "",
      "end_lat": "28.653146",
      "end_lon": "-106.912499",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-CUAU-016-CUAUHTEMOC",
      "name_hostipC": "10.171.152.172",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912499",
        "28.653146"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "NAS-911-NCG-CHIH01-CMM-NUCG-001",
      "latitude": "30.398151",
      "longitude": "-107.91",
      "hostid": 31588,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31588,
      "hostidP": "",
      "end_lat": "30.398151",
      "end_lon": "-107.91",
      "name_hostC": "NAS-911-NCG-CHIH01-CMM-NUCG-001",
      "name_hostipC": "10.171.161.221",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.91",
        "30.398151"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "NAS-911-NCG-CHIH01-CMM-NUCG-001",
      "latitude": "30.398151",
      "longitude": "-107.91",
      "hostid": 31588,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 31588,
      "hostidP": "",
      "end_lat": "30.398151",
      "end_lon": "-107.91",
      "name_hostC": "NAS-911-NCG-CHIH01-CMM-NUCG-001",
      "name_hostipC": "10.171.161.221",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.91",
        "30.398151"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-CAGR-062",
      "latitude": "30.377401",
      "longitude": "-107.952057",
      "hostid": 26168,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26168,
      "hostidP": "",
      "end_lat": "30.377401",
      "end_lon": "-107.952057",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-CAGR-062",
      "name_hostipC": "10.171.163.172",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.952057",
        "30.377401"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-CAGR-062",
      "latitude": "30.377401",
      "longitude": "-107.952057",
      "hostid": 26168,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26168,
      "hostidP": "",
      "end_lat": "30.377401",
      "end_lon": "-107.952057",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-CAGR-062",
      "name_hostipC": "10.171.163.172",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.952057",
        "30.377401"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-Siqura-CHIH01-VVU-NUCG-030-NuevoCasasGrandes-C4",
      "latitude": "30.412736",
      "longitude": "-107.908869",
      "hostid": 16278,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16278,
      "hostidP": "",
      "end_lat": "30.412736",
      "end_lon": "-107.908869",
      "name_hostC": "F2-Siqura-CHIH01-VVU-NUCG-030-NuevoCasasGrandes-C4",
      "name_hostipC": "10.171.165.110",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.908869",
        "30.412736"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-Siqura-CHIH01-VVU-NUCG-030-NuevoCasasGrandes-C4",
      "latitude": "30.412736",
      "longitude": "-107.908869",
      "hostid": 16278,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16278,
      "hostidP": "",
      "end_lat": "30.412736",
      "end_lon": "-107.908869",
      "name_hostC": "F2-Siqura-CHIH01-VVU-NUCG-030-NuevoCasasGrandes-C4",
      "name_hostipC": "10.171.165.110",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.908869",
        "30.412736"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-Siqura-CHIH01-VVU-NUCG-030-NuevoCasasGrandes-C4",
      "latitude": "30.412736",
      "longitude": "-107.908869",
      "hostid": 16277,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16277,
      "hostidP": "",
      "end_lat": "30.412736",
      "end_lon": "-107.908869",
      "name_hostC": "F1-Siqura-CHIH01-VVU-NUCG-030-NuevoCasasGrandes-C4",
      "name_hostipC": "10.171.165.109",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.908869",
        "30.412736"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-Siqura-CHIH01-VVU-NUCG-030-NuevoCasasGrandes-C4",
      "latitude": "30.412736",
      "longitude": "-107.908869",
      "hostid": 16277,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16277,
      "hostidP": "",
      "end_lat": "30.412736",
      "end_lon": "-107.908869",
      "name_hostC": "F1-Siqura-CHIH01-VVU-NUCG-030-NuevoCasasGrandes-C4",
      "name_hostipC": "10.171.165.109",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.908869",
        "30.412736"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-BUEN-131",
      "latitude": "29.840329",
      "longitude": "-107.483538",
      "hostid": 30441,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30441,
      "hostidP": "",
      "end_lat": "29.840329",
      "end_lon": "-107.483538",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-BUEN-131",
      "name_hostipC": "10.171.71.52",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.483538",
        "29.840329"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-BUEN-131",
      "latitude": "29.840329",
      "longitude": "-107.483538",
      "hostid": 30441,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30441,
      "hostidP": "",
      "end_lat": "29.840329",
      "end_lon": "-107.483538",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-BUEN-131",
      "name_hostipC": "10.171.71.52",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.483538",
        "29.840329"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-GALE-137",
      "latitude": "29.979753",
      "longitude": "-107.545028",
      "hostid": 30627,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30627,
      "hostidP": "",
      "end_lat": "29.979753",
      "end_lon": "-107.545028",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-GALE-137",
      "name_hostipC": "10.171.86.34",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.545028",
        "29.979753"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-GALE-137",
      "latitude": "29.979753",
      "longitude": "-107.545028",
      "hostid": 30627,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30627,
      "hostidP": "",
      "end_lat": "29.979753",
      "end_lon": "-107.545028",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-GALE-137",
      "name_hostipC": "10.171.86.34",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.545028",
        "29.979753"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-BUEN-131",
      "latitude": "29.840329",
      "longitude": "-107.483538",
      "hostid": 30624,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30624,
      "hostidP": "",
      "end_lat": "29.840329",
      "end_lon": "-107.483538",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-BUEN-131",
      "name_hostipC": "10.171.86.50",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.483538",
        "29.840329"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-BUEN-131",
      "latitude": "29.840329",
      "longitude": "-107.483538",
      "hostid": 30624,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30624,
      "hostidP": "",
      "end_lat": "29.840329",
      "end_lon": "-107.483538",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-BUEN-131",
      "name_hostipC": "10.171.86.50",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.483538",
        "29.840329"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-NUCG-030-NuevoCasasGrandes-C4",
      "latitude": "30.412736",
      "longitude": "-107.908869",
      "hostid": 16276,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16276,
      "hostidP": "",
      "end_lat": "30.412736",
      "end_lon": "-107.908869",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-NUCG-030-NuevoCasasGrandes-C4",
      "name_hostipC": "10.171.165.108",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.908869",
        "30.412736"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-VVU-NUCG-030-NuevoCasasGrandes-C4",
      "latitude": "30.412736",
      "longitude": "-107.908869",
      "hostid": 16276,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16276,
      "hostidP": "",
      "end_lat": "30.412736",
      "end_lon": "-107.908869",
      "name_hostC": "PTZ-TKH-CHIH01-VVU-NUCG-030-NuevoCasasGrandes-C4",
      "name_hostipC": "10.171.165.108",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.908869",
        "30.412736"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-CAGR-062",
      "latitude": "30.377401",
      "longitude": "-107.952057",
      "hostid": 26166,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26166,
      "hostidP": "",
      "end_lat": "30.377401",
      "end_lon": "-107.952057",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-CAGR-062",
      "name_hostipC": "10.171.163.171",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.952057",
        "30.377401"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-CAGR-062",
      "latitude": "30.377401",
      "longitude": "-107.952057",
      "hostid": 26166,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26166,
      "hostidP": "",
      "end_lat": "30.377401",
      "end_lon": "-107.952057",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-CAGR-062",
      "name_hostipC": "10.171.163.171",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.952057",
        "30.377401"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-Siqura-CHIH01-VVU-GALE-137",
      "latitude": "29.979753",
      "longitude": "-107.545028",
      "hostid": 30630,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30630,
      "hostidP": "",
      "end_lat": "29.979753",
      "end_lon": "-107.545028",
      "name_hostC": "F1-Siqura-CHIH01-VVU-GALE-137",
      "name_hostipC": "10.171.86.35",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.545028",
        "29.979753"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-Siqura-CHIH01-VVU-GALE-137",
      "latitude": "29.979753",
      "longitude": "-107.545028",
      "hostid": 30630,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30630,
      "hostidP": "",
      "end_lat": "29.979753",
      "end_lon": "-107.545028",
      "name_hostC": "F1-Siqura-CHIH01-VVU-GALE-137",
      "name_hostipC": "10.171.86.35",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.545028",
        "29.979753"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-BUEN-003",
      "latitude": "29.84042",
      "longitude": "-107.4833",
      "hostid": 30301,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30301,
      "hostidP": "",
      "end_lat": "29.84042",
      "end_lon": "-107.4833",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-BUEN-003",
      "name_hostipC": "10.171.71.54",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.4833",
        "29.84042"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-BUEN-003",
      "latitude": "29.84042",
      "longitude": "-107.4833",
      "hostid": 30301,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30301,
      "hostidP": "",
      "end_lat": "29.84042",
      "end_lon": "-107.4833",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-BUEN-003",
      "name_hostipC": "10.171.71.54",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.4833",
        "29.84042"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-NUCG-030",
      "latitude": "30.412736",
      "longitude": "-107.908869",
      "hostid": 26208,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26208,
      "hostidP": "",
      "end_lat": "30.412736",
      "end_lon": "-107.908869",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-NUCG-030",
      "name_hostipC": "10.171.165.225",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.908869",
        "30.412736"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-NUCG-030",
      "latitude": "30.412736",
      "longitude": "-107.908869",
      "hostid": 26208,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26208,
      "hostidP": "",
      "end_lat": "30.412736",
      "end_lon": "-107.908869",
      "name_hostC": "LPR1-TKH-BL2002v2LPR-CHIH01-VVU-NUCG-030",
      "name_hostipC": "10.171.165.225",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.908869",
        "30.412736"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-NUCG-036-NuevoCasasGrandes-C4",
      "latitude": "30.429468",
      "longitude": "-107.91838",
      "hostid": 16301,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16301,
      "hostidP": "",
      "end_lat": "30.429468",
      "end_lon": "-107.91838",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-NUCG-036-NuevoCasasGrandes-C4",
      "name_hostipC": "10.171.161.70",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.91838",
        "30.429468"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-NUCG-036-NuevoCasasGrandes-C4",
      "latitude": "30.429468",
      "longitude": "-107.91838",
      "hostid": 16301,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16301,
      "hostidP": "",
      "end_lat": "30.429468",
      "end_lon": "-107.91838",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-NUCG-036-NuevoCasasGrandes-C4",
      "name_hostipC": "10.171.161.70",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.91838",
        "30.429468"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "latitude": "30.3981",
      "longitude": "-107.91",
      "hostid": 30876,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30876,
      "hostidP": "",
      "end_lat": "30.3981",
      "end_lon": "-107.91",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "name_hostipC": "10.171.160.254",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.91",
        "30.3981"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "latitude": "30.3981",
      "longitude": "-107.91",
      "hostid": 30876,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30876,
      "hostidP": "",
      "end_lat": "30.3981",
      "end_lon": "-107.91",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "name_hostipC": "10.171.160.254",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.91",
        "30.3981"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "latitude": "30.3981",
      "longitude": "-107.91",
      "hostid": 30876,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30876,
      "hostidP": "",
      "end_lat": "30.3981",
      "end_lon": "-107.91",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "name_hostipC": "10.171.160.254",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.91",
        "30.3981"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "latitude": "30.3981",
      "longitude": "-107.91",
      "hostid": 30876,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30876,
      "hostidP": "",
      "end_lat": "30.3981",
      "end_lon": "-107.91",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "name_hostipC": "10.171.160.254",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.91",
        "30.3981"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F3-Siqura-CHIH01-VVU-NUCG-048-NuevoCasasGrandes-C4",
      "latitude": "30.410888",
      "longitude": "-107.878992",
      "hostid": 16360,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16360,
      "hostidP": "",
      "end_lat": "30.410888",
      "end_lon": "-107.878992",
      "name_hostC": "F3-Siqura-CHIH01-VVU-NUCG-048-NuevoCasasGrandes-C4",
      "name_hostipC": "10.171.165.154",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.878992",
        "30.410888"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F3-Siqura-CHIH01-VVU-NUCG-048-NuevoCasasGrandes-C4",
      "latitude": "30.410888",
      "longitude": "-107.878992",
      "hostid": 16360,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16360,
      "hostidP": "",
      "end_lat": "30.410888",
      "end_lon": "-107.878992",
      "name_hostC": "F3-Siqura-CHIH01-VVU-NUCG-048-NuevoCasasGrandes-C4",
      "name_hostipC": "10.171.165.154",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.878992",
        "30.410888"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-GALE-105-GALEANA-GALEANA",
      "latitude": "30.115361",
      "longitude": "-107.615135",
      "hostid": 26305,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26305,
      "hostidP": "",
      "end_lat": "30.115361",
      "end_lon": "-107.615135",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-GALE-105-GALEANA-GALEANA",
      "name_hostipC": "10.171.227.51",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.615135",
        "30.115361"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-GALE-105-GALEANA-GALEANA",
      "latitude": "30.115361",
      "longitude": "-107.615135",
      "hostid": 26305,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26305,
      "hostidP": "",
      "end_lat": "30.115361",
      "end_lon": "-107.615135",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-GALE-105-GALEANA-GALEANA",
      "name_hostipC": "10.171.227.51",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.615135",
        "30.115361"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "latitude": "30.3981",
      "longitude": "-107.91",
      "hostid": 30876,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30876,
      "hostidP": "",
      "end_lat": "30.3981",
      "end_lon": "-107.91",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "name_hostipC": "10.171.160.254",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.91",
        "30.3981"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "latitude": "30.3981",
      "longitude": "-107.91",
      "hostid": 30876,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30876,
      "hostidP": "",
      "end_lat": "30.3981",
      "end_lon": "-107.91",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "name_hostipC": "10.171.160.254",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.91",
        "30.3981"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "latitude": "30.3981",
      "longitude": "-107.91",
      "hostid": 30876,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30876,
      "hostidP": "",
      "end_lat": "30.3981",
      "end_lon": "-107.91",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "name_hostipC": "10.171.160.254",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.91",
        "30.3981"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "latitude": "30.3981",
      "longitude": "-107.91",
      "hostid": 30876,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30876,
      "hostidP": "",
      "end_lat": "30.3981",
      "end_lon": "-107.91",
      "name_hostC": "UPS_GENERAL-SUBCENTRO-CHIH01-CMM-NUCG-001",
      "name_hostipC": "10.171.160.254",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.91",
        "30.3981"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-GALE-002",
      "latitude": "29.979753",
      "longitude": "-107.545028",
      "hostid": 30157,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30157,
      "hostidP": "",
      "end_lat": "29.979753",
      "end_lon": "-107.545028",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-GALE-002",
      "name_hostipC": "10.171.71.38",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.545028",
        "29.979753"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-ARC-GALE-002",
      "latitude": "29.979753",
      "longitude": "-107.545028",
      "hostid": 30157,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30157,
      "hostidP": "",
      "end_lat": "29.979753",
      "end_lon": "-107.545028",
      "name_hostC": "SWITCH-MOXA-CHIH01-ARC-GALE-002",
      "name_hostipC": "10.171.71.38",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.545028",
        "29.979753"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F3-Siqura-CHIH01-VVU-NUCG-047-NuevoCasasGrandes-C4",
      "latitude": "30.410869",
      "longitude": "-107.889992",
      "hostid": 16354,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16354,
      "hostidP": "",
      "end_lat": "30.410869",
      "end_lon": "-107.889992",
      "name_hostC": "F3-Siqura-CHIH01-VVU-NUCG-047-NuevoCasasGrandes-C4",
      "name_hostipC": "10.171.165.150",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.889992",
        "30.410869"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F3-Siqura-CHIH01-VVU-NUCG-047-NuevoCasasGrandes-C4",
      "latitude": "30.410869",
      "longitude": "-107.889992",
      "hostid": 16354,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16354,
      "hostidP": "",
      "end_lat": "30.410869",
      "end_lon": "-107.889992",
      "name_hostC": "F3-Siqura-CHIH01-VVU-NUCG-047-NuevoCasasGrandes-C4",
      "name_hostipC": "10.171.165.150",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.889992",
        "30.410869"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-Smart-CHIH01-ARC-BUEN-003",
      "latitude": "29.84042",
      "longitude": "-107.4833",
      "hostid": 30464,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30464,
      "hostidP": "",
      "end_lat": "29.84042",
      "end_lon": "-107.4833",
      "name_hostC": "LPR1-TATTILE-Smart-CHIH01-ARC-BUEN-003",
      "name_hostipC": "10.171.86.54",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.4833",
        "29.84042"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-Smart-CHIH01-ARC-BUEN-003",
      "latitude": "29.84042",
      "longitude": "-107.4833",
      "hostid": 30464,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30464,
      "hostidP": "",
      "end_lat": "29.84042",
      "end_lon": "-107.4833",
      "name_hostC": "LPR1-TATTILE-Smart-CHIH01-ARC-BUEN-003",
      "name_hostipC": "10.171.86.54",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.4833",
        "29.84042"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-GALE-107-GALEANA-GALEANA",
      "latitude": "30.107588",
      "longitude": "-107.613101",
      "hostid": 26307,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26307,
      "hostidP": "",
      "end_lat": "30.107588",
      "end_lon": "-107.613101",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-GALE-107-GALEANA-GALEANA",
      "name_hostipC": "10.171.227.67",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.613101",
        "30.107588"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-GALE-107-GALEANA-GALEANA",
      "latitude": "30.107588",
      "longitude": "-107.613101",
      "hostid": 26307,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26307,
      "hostidP": "",
      "end_lat": "30.107588",
      "end_lon": "-107.613101",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-GALE-107-GALEANA-GALEANA",
      "name_hostipC": "10.171.227.67",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.613101",
        "30.107588"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-CHIH01-VVU-JANO-126",
      "latitude": "30.902892",
      "longitude": "-108.178089",
      "hostid": 30133,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30133,
      "hostidP": "",
      "end_lat": "30.902892",
      "end_lon": "-108.178089",
      "name_hostC": "PTZ-TKH-CHIH01-CHIH01-VVU-JANO-126",
      "name_hostipC": "10.171.85.18",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-108.178089",
        "30.902892"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "PTZ-TKH-CHIH01-CHIH01-VVU-JANO-126",
      "latitude": "30.902892",
      "longitude": "-108.178089",
      "hostid": 30133,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30133,
      "hostidP": "",
      "end_lat": "30.902892",
      "end_lon": "-108.178089",
      "name_hostC": "PTZ-TKH-CHIH01-CHIH01-VVU-JANO-126",
      "name_hostipC": "10.171.85.18",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-108.178089",
        "30.902892"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-Smart-CHIH01-ARC-BUEN-003",
      "latitude": "29.84042",
      "longitude": "-107.4833",
      "hostid": 30465,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30465,
      "hostidP": "",
      "end_lat": "29.84042",
      "end_lon": "-107.4833",
      "name_hostC": "LPR2-TATTILE-Smart-CHIH01-ARC-BUEN-003",
      "name_hostipC": "10.171.86.55",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.4833",
        "29.84042"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-Smart-CHIH01-ARC-BUEN-003",
      "latitude": "29.84042",
      "longitude": "-107.4833",
      "hostid": 30465,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30465,
      "hostidP": "",
      "end_lat": "29.84042",
      "end_lon": "-107.4833",
      "name_hostC": "LPR2-TATTILE-Smart-CHIH01-ARC-BUEN-003",
      "name_hostipC": "10.171.86.55",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.4833",
        "29.84042"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-Smart-CHIH01-ARC-GALE-002",
      "latitude": "29.979753",
      "longitude": "-107.545028",
      "hostid": 30486,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30486,
      "hostidP": "",
      "end_lat": "29.979753",
      "end_lon": "-107.545028",
      "name_hostC": "LPR2-TATTILE-Smart-CHIH01-ARC-GALE-002",
      "name_hostipC": "10.171.86.39",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.545028",
        "29.979753"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TATTILE-Smart-CHIH01-ARC-GALE-002",
      "latitude": "29.979753",
      "longitude": "-107.545028",
      "hostid": 30486,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30486,
      "hostidP": "",
      "end_lat": "29.979753",
      "end_lon": "-107.545028",
      "name_hostC": "LPR2-TATTILE-Smart-CHIH01-ARC-GALE-002",
      "name_hostipC": "10.171.86.39",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.545028",
        "29.979753"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-Siqura-CHIH01-VVU-BUEN-131",
      "latitude": "29.840329",
      "longitude": "-107.483538",
      "hostid": 30611,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30611,
      "hostidP": "",
      "end_lat": "29.840329",
      "end_lon": "-107.483538",
      "name_hostC": "F2-Siqura-CHIH01-VVU-BUEN-131",
      "name_hostipC": "10.171.86.52",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.483538",
        "29.840329"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F2-Siqura-CHIH01-VVU-BUEN-131",
      "latitude": "29.840329",
      "longitude": "-107.483538",
      "hostid": 30611,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30611,
      "hostidP": "",
      "end_lat": "29.840329",
      "end_lon": "-107.483538",
      "name_hostC": "F2-Siqura-CHIH01-VVU-BUEN-131",
      "name_hostipC": "10.171.86.52",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.483538",
        "29.840329"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-Smart-CHIH01-ARC-GALE-002",
      "latitude": "29.979753",
      "longitude": "-107.545028",
      "hostid": 30483,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30483,
      "hostidP": "",
      "end_lat": "29.979753",
      "end_lon": "-107.545028",
      "name_hostC": "LPR1-TATTILE-Smart-CHIH01-ARC-GALE-002",
      "name_hostipC": "10.171.86.38",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.545028",
        "29.979753"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-TATTILE-Smart-CHIH01-ARC-GALE-002",
      "latitude": "29.979753",
      "longitude": "-107.545028",
      "hostid": 30483,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30483,
      "hostidP": "",
      "end_lat": "29.979753",
      "end_lon": "-107.545028",
      "name_hostC": "LPR1-TATTILE-Smart-CHIH01-ARC-GALE-002",
      "name_hostipC": "10.171.86.38",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.545028",
        "29.979753"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-NUCG-093-NuevoCasasGrandes-C4",
      "latitude": "30.391836",
      "longitude": "-107.892117",
      "hostid": 16480,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16480,
      "hostidP": "",
      "end_lat": "30.391836",
      "end_lon": "-107.892117",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-NUCG-093-NuevoCasasGrandes-C4",
      "name_hostipC": "10.171.165.63",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.892117",
        "30.391836"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-NUCG-093-NuevoCasasGrandes-C4",
      "latitude": "30.391836",
      "longitude": "-107.892117",
      "hostid": 16480,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 16480,
      "hostidP": "",
      "end_lat": "30.391836",
      "end_lon": "-107.892117",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-NUCG-093-NuevoCasasGrandes-C4",
      "name_hostipC": "10.171.165.63",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.892117",
        "30.391836"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-NUCG-030",
      "latitude": "30.412736",
      "longitude": "-107.908869",
      "hostid": 26235,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26235,
      "hostidP": "",
      "end_lat": "30.412736",
      "end_lon": "-107.908869",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-NUCG-030",
      "name_hostipC": "10.171.165.226",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.908869",
        "30.412736"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-NUCG-030",
      "latitude": "30.412736",
      "longitude": "-107.908869",
      "hostid": 26235,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26235,
      "hostidP": "",
      "end_lat": "30.412736",
      "end_lon": "-107.908869",
      "name_hostC": "LPR2-TKH-BL2002v2LPR-CHIH01-VVU-NUCG-030",
      "name_hostipC": "10.171.165.226",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.908869",
        "30.412736"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-GALE-106-GALEANA-GALEANA",
      "latitude": "30.114814",
      "longitude": "-107.617664",
      "hostid": 26306,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26306,
      "hostidP": "",
      "end_lat": "30.114814",
      "end_lon": "-107.617664",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-GALE-106-GALEANA-GALEANA",
      "name_hostipC": "10.171.227.59",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.617664",
        "30.114814"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SWITCH-MOXA-CHIH01-VVU-GALE-106-GALEANA-GALEANA",
      "latitude": "30.114814",
      "longitude": "-107.617664",
      "hostid": 26306,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 26306,
      "hostidP": "",
      "end_lat": "30.114814",
      "end_lon": "-107.617664",
      "name_hostC": "SWITCH-MOXA-CHIH01-VVU-GALE-106-GALEANA-GALEANA",
      "name_hostipC": "10.171.227.59",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.617664",
        "30.114814"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-Siqura-CHIH01-VVU-BUEN-131",
      "latitude": "29.840329",
      "longitude": "-107.483538",
      "hostid": 30369,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30369,
      "hostidP": "",
      "end_lat": "29.840329",
      "end_lon": "-107.483538",
      "name_hostC": "F1-Siqura-CHIH01-VVU-BUEN-131",
      "name_hostipC": "10.171.86.51",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.483538",
        "29.840329"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "F1-Siqura-CHIH01-VVU-BUEN-131",
      "latitude": "29.840329",
      "longitude": "-107.483538",
      "hostid": 30369,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 30369,
      "hostidP": "",
      "end_lat": "29.840329",
      "end_lon": "-107.483538",
      "name_hostC": "F1-Siqura-CHIH01-VVU-BUEN-131",
      "name_hostipC": "10.171.86.51",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-107.483538",
        "29.840329"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-062-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.533154",
      "longitude": "-104.442452",
      "hostid": 19263,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19263,
      "hostidP": "",
      "end_lat": "29.533154",
      "end_lon": "-104.442452",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-062-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.70",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.442452",
        "29.533154"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-062-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.533154",
      "longitude": "-104.442452",
      "hostid": 19263,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19263,
      "hostidP": "",
      "end_lat": "29.533154",
      "end_lon": "-104.442452",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-062-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.70",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.442452",
        "29.533154"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-062-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.533154",
      "longitude": "-104.442452",
      "hostid": 19263,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19263,
      "hostidP": "",
      "end_lat": "29.533154",
      "end_lon": "-104.442452",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-062-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.70",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.442452",
        "29.533154"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-062-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.533154",
      "longitude": "-104.442452",
      "hostid": 19263,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19263,
      "hostidP": "",
      "end_lat": "29.533154",
      "end_lon": "-104.442452",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-062-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.70",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.442452",
        "29.533154"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-062-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.533154",
      "longitude": "-104.442452",
      "hostid": 19263,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19263,
      "hostidP": "",
      "end_lat": "29.533154",
      "end_lon": "-104.442452",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-062-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.70",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.442452",
        "29.533154"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-063-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.54226",
      "longitude": "-104.441398",
      "hostid": 19267,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19267,
      "hostidP": "",
      "end_lat": "29.54226",
      "end_lon": "-104.441398",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-063-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.72",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.441398",
        "29.54226"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-063-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.54226",
      "longitude": "-104.441398",
      "hostid": 19267,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19267,
      "hostidP": "",
      "end_lat": "29.54226",
      "end_lon": "-104.441398",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-063-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.72",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.441398",
        "29.54226"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-063-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.54226",
      "longitude": "-104.441398",
      "hostid": 19267,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19267,
      "hostidP": "",
      "end_lat": "29.54226",
      "end_lon": "-104.441398",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-063-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.72",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.441398",
        "29.54226"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-063-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.54226",
      "longitude": "-104.441398",
      "hostid": 19267,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19267,
      "hostidP": "",
      "end_lat": "29.54226",
      "end_lon": "-104.441398",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-063-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.72",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.441398",
        "29.54226"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-078-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.537074",
      "longitude": "-104.414237",
      "hostid": 19310,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19310,
      "hostidP": "",
      "end_lat": "29.537074",
      "end_lon": "-104.414237",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-078-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.86",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.414237",
        "29.537074"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-078-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.537074",
      "longitude": "-104.414237",
      "hostid": 19310,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19310,
      "hostidP": "",
      "end_lat": "29.537074",
      "end_lon": "-104.414237",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-078-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.86",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.414237",
        "29.537074"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-078-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.537074",
      "longitude": "-104.414237",
      "hostid": 19310,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19310,
      "hostidP": "",
      "end_lat": "29.537074",
      "end_lon": "-104.414237",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-078-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.86",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.414237",
        "29.537074"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-078-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.537074",
      "longitude": "-104.414237",
      "hostid": 19310,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19310,
      "hostidP": "",
      "end_lat": "29.537074",
      "end_lon": "-104.414237",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-078-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.86",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.414237",
        "29.537074"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-078-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.537074",
      "longitude": "-104.414237",
      "hostid": 19310,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19310,
      "hostidP": "",
      "end_lat": "29.537074",
      "end_lon": "-104.414237",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-078-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.86",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.414237",
        "29.537074"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-135-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.554337",
      "longitude": "-104.404256",
      "hostid": 19453,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19453,
      "hostidP": "",
      "end_lat": "29.554337",
      "end_lon": "-104.404256",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-135-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.148",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.404256",
        "29.554337"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-039-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.534022",
      "longitude": "-104.458756",
      "hostid": 19476,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19476,
      "hostidP": "",
      "end_lat": "29.534022",
      "end_lon": "-104.458756",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-039-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.156",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.458756",
        "29.534022"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-039-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.534022",
      "longitude": "-104.458756",
      "hostid": 19476,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19476,
      "hostidP": "",
      "end_lat": "29.534022",
      "end_lon": "-104.458756",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-039-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.156",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.458756",
        "29.534022"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-039-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.534022",
      "longitude": "-104.458756",
      "hostid": 19476,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19476,
      "hostidP": "",
      "end_lat": "29.534022",
      "end_lon": "-104.458756",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-039-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.156",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.458756",
        "29.534022"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-039-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.534022",
      "longitude": "-104.458756",
      "hostid": 19476,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19476,
      "hostidP": "",
      "end_lat": "29.534022",
      "end_lon": "-104.458756",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-039-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.156",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.458756",
        "29.534022"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-039-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.534022",
      "longitude": "-104.458756",
      "hostid": 19476,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19476,
      "hostidP": "",
      "end_lat": "29.534022",
      "end_lon": "-104.458756",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-039-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.156",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.458756",
        "29.534022"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-101-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.560871",
      "longitude": "-104.423587",
      "hostid": 19499,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19499,
      "hostidP": "",
      "end_lat": "29.560871",
      "end_lon": "-104.423587",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-101-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.164",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.423587",
        "29.560871"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-101-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.560871",
      "longitude": "-104.423587",
      "hostid": 19499,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19499,
      "hostidP": "",
      "end_lat": "29.560871",
      "end_lon": "-104.423587",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-101-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.164",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.423587",
        "29.560871"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-101-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.560871",
      "longitude": "-104.423587",
      "hostid": 19499,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19499,
      "hostidP": "",
      "end_lat": "29.560871",
      "end_lon": "-104.423587",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-101-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.164",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.423587",
        "29.560871"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-101-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.560871",
      "longitude": "-104.423587",
      "hostid": 19499,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19499,
      "hostidP": "",
      "end_lat": "29.560871",
      "end_lon": "-104.423587",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-101-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.164",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.423587",
        "29.560871"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-101-OJINAGA-HIPERCONVERGENTE",
      "latitude": "29.560871",
      "longitude": "-104.423587",
      "hostid": 19499,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19499,
      "hostidP": "",
      "end_lat": "29.560871",
      "end_lon": "-104.423587",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-OJIN-101-OJINAGA-HIPERCONVERGENTE",
      "name_hostipC": "10.171.232.164",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-104.423587",
        "29.560871"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-014-CUAUHTEMOC-TEC",
      "latitude": "28.503475",
      "longitude": "-106.912064",
      "hostid": 19572,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19572,
      "hostidP": "",
      "end_lat": "28.503475",
      "end_lon": "-106.912064",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-014-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.222",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912064",
        "28.503475"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-014-CUAUHTEMOC-TEC",
      "latitude": "28.503475",
      "longitude": "-106.912064",
      "hostid": 19572,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19572,
      "hostidP": "",
      "end_lat": "28.503475",
      "end_lon": "-106.912064",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-014-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.222",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912064",
        "28.503475"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-014-CUAUHTEMOC-TEC",
      "latitude": "28.503475",
      "longitude": "-106.912064",
      "hostid": 19572,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19572,
      "hostidP": "",
      "end_lat": "28.503475",
      "end_lon": "-106.912064",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-014-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.222",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912064",
        "28.503475"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-023-CUAUHTEMOC-CERROCHIQUIHUITE",
      "latitude": "28.3604486",
      "longitude": "-106.8960871",
      "hostid": 19597,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19597,
      "hostidP": "",
      "end_lat": "28.3604486",
      "end_lon": "-106.8960871",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-023-CUAUHTEMOC-CERROCHIQUIHUITE",
      "name_hostipC": "10.171.152.34",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.8960871",
        "28.3604486"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-023-CUAUHTEMOC-CERROCHIQUIHUITE",
      "latitude": "28.3604486",
      "longitude": "-106.8960871",
      "hostid": 19597,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19597,
      "hostidP": "",
      "end_lat": "28.3604486",
      "end_lon": "-106.8960871",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-023-CUAUHTEMOC-CERROCHIQUIHUITE",
      "name_hostipC": "10.171.152.34",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.8960871",
        "28.3604486"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-072-CUAUHTEMOC-SUBCENTRO",
      "latitude": "28.42936",
      "longitude": "-106.85011",
      "hostid": 19622,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19622,
      "hostidP": "",
      "end_lat": "28.42936",
      "end_lon": "-106.85011",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-072-CUAUHTEMOC-SUBCENTRO",
      "name_hostipC": "10.169.116.182",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.85011",
        "28.42936"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-046-CUAUHTEMOC-CERROCHIQUIHUITE",
      "latitude": "28.42815528",
      "longitude": "-106.8312931",
      "hostid": 19716,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19716,
      "hostidP": "",
      "end_lat": "28.42815528",
      "end_lon": "-106.8312931",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-046-CUAUHTEMOC-CERROCHIQUIHUITE",
      "name_hostipC": "10.169.115.24",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.8312931",
        "28.42815528"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-046-CUAUHTEMOC-CERROCHIQUIHUITE",
      "latitude": "28.42815528",
      "longitude": "-106.8312931",
      "hostid": 19716,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19716,
      "hostidP": "",
      "end_lat": "28.42815528",
      "end_lon": "-106.8312931",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-046-CUAUHTEMOC-CERROCHIQUIHUITE",
      "name_hostipC": "10.169.115.24",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.8312931",
        "28.42815528"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-046-CUAUHTEMOC-CERROCHIQUIHUITE",
      "latitude": "28.42815528",
      "longitude": "-106.8312931",
      "hostid": 19716,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19716,
      "hostidP": "",
      "end_lat": "28.42815528",
      "end_lon": "-106.8312931",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-046-CUAUHTEMOC-CERROCHIQUIHUITE",
      "name_hostipC": "10.169.115.24",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.8312931",
        "28.42815528"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-046-CUAUHTEMOC-CERROCHIQUIHUITE",
      "latitude": "28.42815528",
      "longitude": "-106.8312931",
      "hostid": 19716,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19716,
      "hostidP": "",
      "end_lat": "28.42815528",
      "end_lon": "-106.8312931",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-046-CUAUHTEMOC-CERROCHIQUIHUITE",
      "name_hostipC": "10.169.115.24",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.8312931",
        "28.42815528"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-046-CUAUHTEMOC-CERROCHIQUIHUITE",
      "latitude": "28.42815528",
      "longitude": "-106.8312931",
      "hostid": 19716,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19716,
      "hostidP": "",
      "end_lat": "28.42815528",
      "end_lon": "-106.8312931",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-046-CUAUHTEMOC-CERROCHIQUIHUITE",
      "name_hostipC": "10.169.115.24",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.8312931",
        "28.42815528"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-064-CUAUHTEMOC-TEC",
      "latitude": "28.5355367",
      "longitude": "-106.9119223",
      "hostid": 19807,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19807,
      "hostidP": "",
      "end_lat": "28.5355367",
      "end_lon": "-106.9119223",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-064-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.220",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.9119223",
        "28.5355367"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-064-CUAUHTEMOC-TEC",
      "latitude": "28.5355367",
      "longitude": "-106.9119223",
      "hostid": 19807,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19807,
      "hostidP": "",
      "end_lat": "28.5355367",
      "end_lon": "-106.9119223",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-064-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.220",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.9119223",
        "28.5355367"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-064-CUAUHTEMOC-TEC",
      "latitude": "28.5355367",
      "longitude": "-106.9119223",
      "hostid": 19807,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19807,
      "hostidP": "",
      "end_lat": "28.5355367",
      "end_lon": "-106.9119223",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-064-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.220",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.9119223",
        "28.5355367"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-064-CUAUHTEMOC-TEC",
      "latitude": "28.5355367",
      "longitude": "-106.9119223",
      "hostid": 19807,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19807,
      "hostidP": "",
      "end_lat": "28.5355367",
      "end_lon": "-106.9119223",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-064-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.220",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.9119223",
        "28.5355367"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-068-CUAUHTEMOC-TEC",
      "latitude": "28.574042",
      "longitude": "-106.912053",
      "hostid": 19824,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19824,
      "hostidP": "",
      "end_lat": "28.574042",
      "end_lon": "-106.912053",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-068-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.218",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912053",
        "28.574042"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-068-CUAUHTEMOC-TEC",
      "latitude": "28.574042",
      "longitude": "-106.912053",
      "hostid": 19824,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19824,
      "hostidP": "",
      "end_lat": "28.574042",
      "end_lon": "-106.912053",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-068-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.218",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912053",
        "28.574042"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-068-CUAUHTEMOC-TEC",
      "latitude": "28.574042",
      "longitude": "-106.912053",
      "hostid": 19824,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19824,
      "hostidP": "",
      "end_lat": "28.574042",
      "end_lon": "-106.912053",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-068-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.218",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912053",
        "28.574042"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-074-CUAUHTEMOC-TEC",
      "latitude": "28.432461",
      "longitude": "-106.907529",
      "hostid": 19861,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19861,
      "hostidP": "",
      "end_lat": "28.432461",
      "end_lon": "-106.907529",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-074-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.162",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.907529",
        "28.432461"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-076-CUAUHTEMOC-TEC",
      "latitude": "28.541806",
      "longitude": "-106.912054",
      "hostid": 19870,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19870,
      "hostidP": "",
      "end_lat": "28.541806",
      "end_lon": "-106.912054",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-076-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.216",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912054",
        "28.541806"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-076-CUAUHTEMOC-TEC",
      "latitude": "28.541806",
      "longitude": "-106.912054",
      "hostid": 19870,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19870,
      "hostidP": "",
      "end_lat": "28.541806",
      "end_lon": "-106.912054",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-076-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.216",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912054",
        "28.541806"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-076-CUAUHTEMOC-TEC",
      "latitude": "28.541806",
      "longitude": "-106.912054",
      "hostid": 19870,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 19870,
      "hostidP": "",
      "end_lat": "28.541806",
      "end_lon": "-106.912054",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-076-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.216",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.912054",
        "28.541806"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-135-CUAUHTEMOC-TEC",
      "latitude": "28.468702",
      "longitude": "-106.911725",
      "hostid": 20138,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20138,
      "hostidP": "",
      "end_lat": "28.468702",
      "end_lon": "-106.911725",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-135-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.180",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.911725",
        "28.468702"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-135-CUAUHTEMOC-TEC",
      "latitude": "28.468702",
      "longitude": "-106.911725",
      "hostid": 20138,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20138,
      "hostidP": "",
      "end_lat": "28.468702",
      "end_lon": "-106.911725",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-135-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.180",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.911725",
        "28.468702"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-006-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.492686",
      "longitude": "-106.745925",
      "hostid": 20166,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20166,
      "hostidP": "",
      "end_lat": "28.492686",
      "end_lon": "-106.745925",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-006-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.81",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.745925",
        "28.492686"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-006-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.492686",
      "longitude": "-106.745925",
      "hostid": 20166,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20166,
      "hostidP": "",
      "end_lat": "28.492686",
      "end_lon": "-106.745925",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-006-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.81",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.745925",
        "28.492686"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-006-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.492686",
      "longitude": "-106.745925",
      "hostid": 20166,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20166,
      "hostidP": "",
      "end_lat": "28.492686",
      "end_lon": "-106.745925",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-006-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.81",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.745925",
        "28.492686"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-006-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.492686",
      "longitude": "-106.745925",
      "hostid": 20166,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20166,
      "hostidP": "",
      "end_lat": "28.492686",
      "end_lon": "-106.745925",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-006-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.81",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.745925",
        "28.492686"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-006-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.492686",
      "longitude": "-106.745925",
      "hostid": 20166,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20166,
      "hostidP": "",
      "end_lat": "28.492686",
      "end_lon": "-106.745925",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-006-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.81",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.745925",
        "28.492686"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-052-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.4834626",
      "longitude": "-106.731876",
      "hostid": 20184,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20184,
      "hostidP": "",
      "end_lat": "28.4834626",
      "end_lon": "-106.731876",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-052-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.91",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.731876",
        "28.4834626"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-052-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.4834626",
      "longitude": "-106.731876",
      "hostid": 20184,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20184,
      "hostidP": "",
      "end_lat": "28.4834626",
      "end_lon": "-106.731876",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-052-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.91",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.731876",
        "28.4834626"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-052-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.4834626",
      "longitude": "-106.731876",
      "hostid": 20184,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20184,
      "hostidP": "",
      "end_lat": "28.4834626",
      "end_lon": "-106.731876",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-052-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.91",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.731876",
        "28.4834626"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-052-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.4834626",
      "longitude": "-106.731876",
      "hostid": 20184,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20184,
      "hostidP": "",
      "end_lat": "28.4834626",
      "end_lon": "-106.731876",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-052-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.91",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.731876",
        "28.4834626"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-053-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.4823829",
      "longitude": "-106.7531348",
      "hostid": 20188,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20188,
      "hostidP": "",
      "end_lat": "28.4823829",
      "end_lon": "-106.7531348",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-053-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.93",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.7531348",
        "28.4823829"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-053-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.4823829",
      "longitude": "-106.7531348",
      "hostid": 20188,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20188,
      "hostidP": "",
      "end_lat": "28.4823829",
      "end_lon": "-106.7531348",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-053-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.93",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.7531348",
        "28.4823829"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-053-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.4823829",
      "longitude": "-106.7531348",
      "hostid": 20188,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20188,
      "hostidP": "",
      "end_lat": "28.4823829",
      "end_lon": "-106.7531348",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-053-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.93",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.7531348",
        "28.4823829"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-053-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.4823829",
      "longitude": "-106.7531348",
      "hostid": 20188,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20188,
      "hostidP": "",
      "end_lat": "28.4823829",
      "end_lon": "-106.7531348",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-053-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.93",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.7531348",
        "28.4823829"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-053-CUAUHTEMOC-R.RANAHUAC",
      "latitude": "28.4823829",
      "longitude": "-106.7531348",
      "hostid": 20188,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20188,
      "hostidP": "",
      "end_lat": "28.4823829",
      "end_lon": "-106.7531348",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-053-CUAUHTEMOC-R.RANAHUAC",
      "name_hostipC": "10.171.152.93",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.7531348",
        "28.4823829"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-146-CUAUHTEMOC-TEC",
      "latitude": "28.457646",
      "longitude": "-106.911751",
      "hostid": 20193,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20193,
      "hostidP": "",
      "end_lat": "28.457646",
      "end_lon": "-106.911751",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-146-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.182",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.911751",
        "28.457646"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-146-CUAUHTEMOC-TEC",
      "latitude": "28.457646",
      "longitude": "-106.911751",
      "hostid": 20193,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20193,
      "hostidP": "",
      "end_lat": "28.457646",
      "end_lon": "-106.911751",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-146-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.182",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.911751",
        "28.457646"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-146-CUAUHTEMOC-TEC",
      "latitude": "28.457646",
      "longitude": "-106.911751",
      "hostid": 20193,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20193,
      "hostidP": "",
      "end_lat": "28.457646",
      "end_lon": "-106.911751",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-146-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.182",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.911751",
        "28.457646"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-146-CUAUHTEMOC-TEC",
      "latitude": "28.457646",
      "longitude": "-106.911751",
      "hostid": 20193,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20193,
      "hostidP": "",
      "end_lat": "28.457646",
      "end_lon": "-106.911751",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-146-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.182",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.911751",
        "28.457646"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-146-CUAUHTEMOC-TEC",
      "latitude": "28.457646",
      "longitude": "-106.911751",
      "hostid": 20193,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 20193,
      "hostidP": "",
      "end_lat": "28.457646",
      "end_lon": "-106.911751",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CUAU-146-CUAUHTEMOC-TEC",
      "name_hostipC": "10.171.42.182",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.911751",
        "28.457646"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "latitude": "31.27163",
      "longitude": "-105.855702",
      "hostid": 23075,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 23075,
      "hostidP": "",
      "end_lat": "31.27163",
      "end_lon": "-105.855702",
      "name_hostC": "LPR1-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "name_hostipC": "10.171.226.90",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.855702",
        "31.27163"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "latitude": "31.27163",
      "longitude": "-105.855702",
      "hostid": 23075,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 23075,
      "hostidP": "",
      "end_lat": "31.27163",
      "end_lon": "-105.855702",
      "name_hostC": "LPR1-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "name_hostipC": "10.171.226.90",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.855702",
        "31.27163"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "latitude": "31.27163",
      "longitude": "-105.855702",
      "hostid": 23076,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 23076,
      "hostidP": "",
      "end_lat": "31.27163",
      "end_lon": "-105.855702",
      "name_hostC": "LPR2-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "name_hostipC": "10.171.226.91",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.855702",
        "31.27163"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "latitude": "31.27163",
      "longitude": "-105.855702",
      "hostid": 23076,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 23076,
      "hostidP": "",
      "end_lat": "31.27163",
      "end_lon": "-105.855702",
      "name_hostC": "LPR2-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "name_hostipC": "10.171.226.91",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.855702",
        "31.27163"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR1-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "latitude": "31.27163",
      "longitude": "-105.855702",
      "hostid": 23075,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 23075,
      "hostidP": "",
      "end_lat": "31.27163",
      "end_lon": "-105.855702",
      "name_hostC": "LPR1-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "name_hostipC": "10.171.226.90",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.855702",
        "31.27163"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "LPR2-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "latitude": "31.27163",
      "longitude": "-105.855702",
      "hostid": 23076,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 23076,
      "hostidP": "",
      "end_lat": "31.27163",
      "end_lon": "-105.855702",
      "name_hostC": "LPR2-VVU-TKH-BL2002v2LPR-CHIH01-VVU-CDJU-181",
      "name_hostipC": "10.171.226.91",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.855702",
        "31.27163"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-068-CHIHUAHUA-CECYT_20",
      "latitude": "28.604279",
      "longitude": "-105.937112",
      "hostid": 24279,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 24279,
      "hostidP": "",
      "end_lat": "28.604279",
      "end_lon": "-105.937112",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-068-CHIHUAHUA-CECYT_20",
      "name_hostipC": "10.171.128.151",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.937112",
        "28.604279"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-068-CHIHUAHUA-CECYT_20",
      "latitude": "28.604279",
      "longitude": "-105.937112",
      "hostid": 24279,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 24279,
      "hostidP": "",
      "end_lat": "28.604279",
      "end_lon": "-105.937112",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-068-CHIHUAHUA-CECYT_20",
      "name_hostipC": "10.171.128.151",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-105.937112",
        "28.604279"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-002-CHIHUAHUA-CERRO_C4",
      "latitude": "28.611588",
      "longitude": "-106.05024",
      "hostid": 24283,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 24283,
      "hostidP": "",
      "end_lat": "28.611588",
      "end_lon": "-106.05024",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-002-CHIHUAHUA-CERRO_C4",
      "name_hostipC": "10.171.116.36",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.05024",
        "28.611588"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-002-CHIHUAHUA-CERRO_C4",
      "latitude": "28.611588",
      "longitude": "-106.05024",
      "hostid": 24283,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 24283,
      "hostidP": "",
      "end_lat": "28.611588",
      "end_lon": "-106.05024",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-002-CHIHUAHUA-CERRO_C4",
      "name_hostipC": "10.171.116.36",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.05024",
        "28.611588"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-002-CHIHUAHUA-CERRO_C4",
      "latitude": "28.611588",
      "longitude": "-106.05024",
      "hostid": 24283,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 24283,
      "hostidP": "",
      "end_lat": "28.611588",
      "end_lon": "-106.05024",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-002-CHIHUAHUA-CERRO_C4",
      "name_hostipC": "10.171.116.36",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.05024",
        "28.611588"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-156-CHIHUAHUA-CERRO_C4",
      "latitude": "28.649357",
      "longitude": "-106.070952",
      "hostid": 24389,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 24389,
      "hostidP": "",
      "end_lat": "28.649357",
      "end_lon": "-106.070952",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-156-CHIHUAHUA-CERRO_C4",
      "name_hostipC": "10.171.123.56",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.070952",
        "28.649357"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-156-CHIHUAHUA-CERRO_C4",
      "latitude": "28.649357",
      "longitude": "-106.070952",
      "hostid": 24389,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 24389,
      "hostidP": "",
      "end_lat": "28.649357",
      "end_lon": "-106.070952",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-156-CHIHUAHUA-CERRO_C4",
      "name_hostipC": "10.171.123.56",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.070952",
        "28.649357"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-156-CHIHUAHUA-CERRO_C4",
      "latitude": "28.649357",
      "longitude": "-106.070952",
      "hostid": 24389,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 24389,
      "hostidP": "",
      "end_lat": "28.649357",
      "end_lon": "-106.070952",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-156-CHIHUAHUA-CERRO_C4",
      "name_hostipC": "10.171.123.56",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.070952",
        "28.649357"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-156-CHIHUAHUA-CERRO_C4",
      "latitude": "28.649357",
      "longitude": "-106.070952",
      "hostid": 24389,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 24389,
      "hostidP": "",
      "end_lat": "28.649357",
      "end_lon": "-106.070952",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-156-CHIHUAHUA-CERRO_C4",
      "name_hostipC": "10.171.123.56",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.070952",
        "28.649357"
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Name": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-198-CHIHUAHUA-CERRO_C4",
      "latitude": "28.63748",
      "longitude": "-106.071881",
      "hostid": 24426,
      "descripcion": "ICMP ping",
      "value": 1,
      "hostidC": 24426,
      "hostidP": "",
      "end_lat": "28.63748",
      "end_lon": "-106.071881",
      "name_hostC": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CHIH-198-CHIHUAHUA-CERRO_C4",
      "name_hostipC": "10.171.123.96",
      "origen": 1,
      "color_alineacion2": "#ff0000",
      "color_alineacion": "#ff0000",
      "metrics": [],
      "level": -1,
      "status": -1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "-106.071881",
        "28.63748"
      ]
    }
  }
]
export {dataExample}